(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artwork-proof-hub"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var wrap = document.querySelector('.ph-wrap');
    if (!wrap) return;
    var workerUrl = (wrap.dataset.workerUrl || '').replace(/\/+$/, '');
    var requestUrl = wrap.dataset.requestUrl || '';
    var defaultOrderUrl = wrap.dataset.orderUrl || '';
    // Standard list first (photos from Shopify Files named hub-<product>.jpg), then any section blocks.
    // A block with the same name replaces the standard one but keeps its photo if the block has none.
    var PRODUCTS = [], prodIdx = {};
    Array.prototype.forEach.call(document.querySelectorAll('#ph-products span'), function (s) {
      var p = { name: s.getAttribute('data-name') || '', price: s.getAttribute('data-price') || '', img: s.getAttribute('data-img') || '' };
      if (!p.name) return;
      var k = p.name.toLowerCase();
      if (k in prodIdx) { var old = PRODUCTS[prodIdx[k]]; PRODUCTS[prodIdx[k]] = { name: p.name, price: p.price || old.price, img: p.img || old.img }; }
      else { prodIdx[k] = PRODUCTS.length; PRODUCTS.push(p); }
    });
    if (!PRODUCTS.length) PRODUCTS = ['Tee', 'Hoodie', 'Trucker cap', 'Fishing shirt', 'Shorts', 'Beanie', 'Bucket hat', 'Stubby cooler', 'Bar mat', 'Keyring'].map(function (n) { return { name: n, price: '', img: '' }; });
    var picked = {}, rqNoteVal = '';
    var confirmLabel = wrap.dataset.confirmLabel || 'I confirm the spelling, colours and layout are correct and approve this artwork for production.';
    var params = new URLSearchParams(window.location.search);
    var J = params.get('j') || '';
    var T = params.get('t') || '';

    var elState = document.getElementById('ph-state');
    var elApp = document.getElementById('ph-app');
    var elTitle = document.getElementById('ph-title');
    var elSub = document.getElementById('ph-sub');
    var elSteps = document.getElementById('ph-steps');
    var elFocus = document.getElementById('ph-focus');
    var elLog = document.getElementById('ph-log');
    var elComposerHost = document.getElementById('ph-composer-host');

    var data = null, lastSig = '', composer = null, approveOpen = false, briefEditing = false, briefExpanded = false;
    var elBrief = document.getElementById('ph-brief');
    var elDesign = document.getElementById('ph-design');

    function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;'); }
    function toDate(s) { if (!s) return null; var iso = /\dT/.test(s) ? s : String(s).replace(' ', 'T') + 'Z'; var d = new Date(iso); return isNaN(d) ? null : d; }
    function fmtTime(d) { return d.toLocaleTimeString('en-AU', { hour: 'numeric', minute: '2-digit' }); }
    function fmtDay(d) { return d.toLocaleDateString('en-AU', { weekday: 'short', day: 'numeric', month: 'short' }); }
    function fmtFull(s) { var d = toDate(s); return d ? d.toLocaleString('en-AU', { day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit' }) : ''; }
    function jobName(t) { return String(t || 'Your artwork').replace(/\s*[-\u2013\u2014]\s*artwork\s*$/i, ''); }
    function isImg(n) { return /\.(png|jpe?g|gif|webp|avif|svg)(\?|$)/i.test(String(n || '')); }
    function extOf(n) { var m = /\.([a-z0-9]{1,5})(\?|$)/i.exec(String(n || '')); return m ? m[1].toUpperCase() : 'FILE'; }
    function icon(d) { return '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="' + d + '" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>'; }
    var IC = {
      send: 'M3 10l14-7-5 14-2.5-5.5z M9.5 11.5L17 3',
      clip: 'M15.5 9.5l-5.8 5.8a3.5 3.5 0 0 1-5-5L11 4a2.3 2.3 0 0 1 3.3 3.3l-6.2 6.2a1.2 1.2 0 0 1-1.7-1.7L12 6.2',
      check: 'M4 10.5l4 4 8-9',
      edit: 'M4 16l1-4 8.5-8.5a1.8 1.8 0 0 1 2.5 2.5L7.5 14.5z',
      print: 'M5 8V3h10v5 M5 14H3V8h14v6h-2 M5 11h10v6H5z',
      down: 'M10 3v10 M5.5 9l4.5 4.5L14.5 9 M4 17h12',
      cart: 'M3 4h2l2 9h9l2-6H6.5 M8 17h.01 M15 17h.01',
      arrow: 'M5 10h10 M11 6l4 4-4 4',
      x: 'M5 5l10 10 M15 5L5 15',
      plus: 'M10 4v12 M4 10h12',
      heart: 'M10 16.5s-6.5-3.8-6.5-8.3A3.6 3.6 0 0 1 10 6a3.6 3.6 0 0 1 6.5 2.2c0 4.5-6.5 8.3-6.5 8.3z'
    };
    function human(v) {
      var s = String(v == null ? '' : v).trim();
      if (/^[a-z0-9_]+$/.test(s)) { s = s.replace(/_/g, ' '); s = s.charAt(0).toUpperCase() + s.slice(1); }
      return s;
    }
    function parseDeadline(v) { var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(v || '').trim()); return m ? new Date(+m[1], +m[2] - 1, +m[3]) : null; }
    function fmtDeadline(v) { var d = parseDeadline(v); return d ? d.toLocaleDateString('en-AU', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' }) : String(v || ''); }
    function daysLeft(v) { var d = parseDeadline(v); if (!d) return null; var t = new Date(); t.setHours(0, 0, 0, 0); return Math.round((d - t) / 86400000); }
    function money(n) { n = Number(n) || 0; return '$' + n.toLocaleString('en-AU', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }); }
    function parseBody(body) {
      var files = [];
      var text = String(body || '').replace(/\[\[file:([^|\]]+)\|?([^\]]*)\]\]/g, function (_, url, name) { files.push({ url: url, filename: name || 'file' }); return ''; }).trim();
      return { text: text, files: files };
    }
    function api(path, opts) {
      return fetch(workerUrl + path, opts).then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (b) { return { ok: res.ok, status: res.status, body: b }; });
      });
    }
    function stateMsg(title, text, showRequest) {
      elApp.hidden = true; elState.hidden = false;
      elState.innerHTML = '<h2>' + esc(title) + '</h2><p>' + esc(text) + '</p>' +
        (showRequest && requestUrl ? '<a class="ph-btn ph-btn-ghost" href="' + esc(requestUrl) + '">Request artwork</a>' : '');
    }

    /* ---- Load + poll ----------------------------------------------------- */

    function load(quiet) {
      if (!workerUrl) { stateMsg('Page not set up', 'The Proof Worker URL is missing from this section\u2019s settings.', false); return Promise.resolve(); }
      if (!J || !T) { stateMsg('Use the link from your email', 'This page opens from the link in the emails we send you. Can\u2019t find it? Reply to any of our emails and we\u2019ll resend it.', true); return Promise.resolve(); }
      return api('/job?j=' + encodeURIComponent(J) + '&t=' + encodeURIComponent(T)).then(function (r) {
        if (!r.ok || !r.body || !r.body.success) {
          if (!quiet) stateMsg('This link isn\u2019t working', 'It may have expired or been mistyped. Reply to any of our emails and we\u2019ll send you a fresh link.', true);
          return;
        }
        var sig = JSON.stringify([r.body.job && r.body.job.status, r.body.job && r.body.job.brief, r.body.rounds, r.body.chat]);
        if (quiet && sig === lastSig) return;
        lastSig = sig; data = r.body;
        render();
      }).catch(function () { if (!quiet) stateMsg('Connection problem', 'Check your internet connection and refresh the page.', false); });
    }
    setInterval(function () {
      if (document.hidden || !data) return;
      if (composer && (composer.busy || composer.dirty())) return;
      if (approveOpen || briefEditing || document.querySelector('.ph-lb')) return;
      load(true);
    }, 5000);
    document.addEventListener('visibilitychange', function () { if (!document.hidden && data) load(true); });

    /* ---- Render ---------------------------------------------------------- */

    var STEP_KEYS = ['brief', 'design', 'review', 'approved'];
    var STEP_LABEL = { brief: 'Brief', design: 'Design', review: 'Review', approved: 'Approved' };

    function render() {
      var job = data.job || {}, rounds = data.rounds || [], chat = data.chat || [];
      var latest = rounds.length ? rounds[rounds.length - 1] : null;
      elTitle.textContent = jobName(job.title);
      elSub.textContent = job.contact_name ? 'Hi ' + String(job.contact_name).split(' ')[0] + ', this is your private artwork page.' : 'Your private artwork page.';

      var step = job.status === 'approved' ? 3 : latest ? (job.status === 'changes_requested' ? 1 : 2) : (job.status === 'in_design' ? 1 : 0);
      if (latest && latest.status === 'approved') step = 3;
      elSteps.innerHTML = STEP_KEYS.map(function (k, i) {
        return '<li class="' + (i < step ? 'is-done' : i === step ? 'is-now' : '') + '">' + STEP_LABEL[k] + '</li>';
      }).join('');

      renderDesign();
      if (!briefEditing) renderBriefPanel(job);
      renderFocus(job, latest);
      renderLog(job, rounds, chat);
      if (!composer) { composer = buildComposer(job); elComposerHost.appendChild(composer.el); }
      elState.hidden = true; elApp.hidden = false;
    }

    function galleryEl(files) {
      var g = document.createElement('div'); g.className = 'ph-gallery';
      var urls = files.map(function (f) { return f.url; });
      files.forEach(function (f, i) {
        var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Enlarge image ' + (i + 1));
        var im = document.createElement('img'); im.src = f.url; im.alt = f.filename || ''; im.loading = 'lazy';
        b.appendChild(im); b.addEventListener('click', function () { lightbox(urls, i); });
        g.appendChild(b);
      });
      return g;
    }

    // The design to show everywhere: the approved round, else the newest proof.
    function designRound() {
      var rounds = (data && data.rounds) || [], pick = null;
      rounds.forEach(function (r) { if (r.approval || r.status === 'approved') pick = r; });
      if (!pick) for (var i = rounds.length - 1; i >= 0; i--) { if ((rounds[i].files || []).some(function (f) { return isImg(f.filename) || isImg(f.url); })) { pick = rounds[i]; break; } }
      return pick;
    }
    function designImage() {
      var r = designRound(); if (!r) return null;
      var imgs = (r.files || []).filter(function (f) { return isImg(f.filename) || isImg(f.url); });
      return imgs.length ? { url: imgs[0].url, all: imgs.map(function (f) { return f.url; }), round: r } : null;
    }
    function renderDesign() {
      var d = designImage(), r = designRound();
      elDesign.innerHTML = '';
      if (!d) {
        elDesign.innerHTML = '<div class="ph-design-empty"><strong>Your design will show here</strong>Once we send your first proof</div>' +
          '<div class="ph-design-cap"><div><strong>Your design</strong><span>In progress</span></div><span class="ph-design-pill">Designing</span></div>';
        return;
      }
      var ok = !!(r.approval || r.status === 'approved');
      var b = document.createElement('button'); b.type = 'button'; b.className = 'ph-design-img'; b.setAttribute('aria-label', 'Enlarge your design');
      b.innerHTML = '<img alt="Your design" src="' + esc(d.url) + '">';
      b.addEventListener('click', function () { lightbox(d.all, 0); });
      var cap = document.createElement('div'); cap.className = 'ph-design-cap';
      cap.innerHTML = '<div><strong>Your design</strong><span>' + (ok ? 'Approved, round ' : 'Round ') + esc(r.round_number) + (d.all.length > 1 ? ' \u00b7 ' + d.all.length + ' images' : '') + '</span></div>' +
        '<span class="ph-design-pill ' + (ok ? 'is-ok' : r.status === 'changes_requested' ? '' : 'is-wait') + '">' + (ok ? 'Approved' : r.status === 'changes_requested' ? 'Updating' : 'To review') + '</span>';
      elDesign.appendChild(b); elDesign.appendChild(cap);
    }

    function renderFocus(job, latest) {
      elFocus.innerHTML = '';
      approveOpen = false;
      var card = document.createElement('div'); card.className = 'ph-card';
      if (!latest) {
        card.innerHTML = '<div class="ph-card-label">In progress</div><h2>We\u2019re working on your design</h2>' +
          '<p>We\u2019ll email you as soon as your first proof is ready. Questions in the meantime? Send us a message below.</p>';
        elFocus.appendChild(card); return;
      }
      var after = ['approved', 'mockups_sent', 'ordered', 'in_production', 'shipped', 'complete'].indexOf(job.status) !== -1;
      if (latest.approval || latest.status === 'approved' || after) {
        renderAfterApproval(job, latest); return;
      }
      var changes = latest.status === 'changes_requested';
      card.className = 'ph-card' + (changes ? '' : ' is-action');
      card.innerHTML = changes
        ? '<div class="ph-card-label">Round ' + esc(latest.round_number) + '</div><h2>We\u2019re making your changes</h2><p>Thanks for the feedback. We\u2019ll send the next round shortly. You can still approve this one if you change your mind.</p>'
        : '<div class="ph-card-label">Round ' + esc(latest.round_number) + ' proof</div><h2>Your proof is ready for review</h2><p>Have a good look, then approve it or tell us what to change.</p>';
      if (latest.files && latest.files.length) card.appendChild(galleryEl(latest.files));
      if (latest.note) {
        var n = document.createElement('div'); n.className = 'ph-note';
        n.innerHTML = '<strong>Note from the designer</strong>'; n.appendChild(document.createTextNode(latest.note));
        card.appendChild(n);
      }
      card.appendChild(buildReady(job, latest));
      var bChanges = document.createElement('button'); bChanges.type = 'button'; bChanges.className = 'ph-btn ph-btn-ghost ph-changes-btn'; bChanges.innerHTML = icon(IC.edit) + (changes ? 'Add more changes' : 'Not quite, request changes');
      bChanges.addEventListener('click', function () { if (composer) composer.changesMode(latest.round_number); });
      card.appendChild(bChanges);
      elFocus.appendChild(card);
    }

    // After approval: mockups, order button, final files (if shared).
    function mockName(fn, i) {
      var n = String(fn || '').replace(/\.[a-z0-9]+$/i, '').replace(/[-_]+/g, ' ').replace(/\s+/g, ' ').trim();
      if (!n || /^(img|image|mockup|dsc|photo)?\s?\d*$/i.test(n)) return 'Mockup ' + (i + 1);
      return n.charAt(0).toUpperCase() + n.slice(1);
    }
    function secHead(title, sub, action) {
      var h = document.createElement('div'); h.className = 'ph-sec-head';
      h.innerHTML = '<div><h2>' + esc(title) + '</h2>' + (sub ? '<span>' + esc(sub) + '</span>' : '') + '</div>';
      if (action) h.appendChild(action);
      return h;
    }

    function renderAfterApproval(job, latest) {
      var mockups = data.mockups || [], finals = data.finals || [], prod = data.production || {};
      var choices = prod.choices || {}, requests = prod.requests || [];
      var a = latest.approval;

      // 1. Slim approved banner
      var ban = document.createElement('div'); ban.className = 'ph-banner';
      ban.innerHTML = '<span class="ph-banner-icon">' + icon(IC.check) + '</span>' +
        '<div class="ph-banner-text"><strong>' + (job.status === 'complete' ? 'Job complete' : 'Artwork approved for printing') + '</strong>' +
        '<span>' + (a ? 'Confirmed by ' + esc(a.signed_name) + ' on ' + esc(fmtFull(a.approved_at)) : 'Round ' + esc(latest.round_number)) + '</span></div>';
      var orderUrl = prod.order_url || defaultOrderUrl;
      if (orderUrl) {
        var ol = document.createElement('a'); ol.className = 'ph-banner-link'; ol.href = orderUrl;
        ol.innerHTML = 'Order page ' + icon(IC.arrow);
        ban.appendChild(ol);
      }
      elFocus.appendChild(ban);

      // 2. Mockups
      var sec = document.createElement('section'); sec.className = 'ph-sec';
      if (mockups.length) {
        var wanted = mockups.filter(function (m) { return choices[m.id] && choices[m.id].choice === 'yes'; }).length;
        sec.appendChild(secHead('Your mockups', wanted ? wanted + ' of ' + mockups.length + ' marked as wanted' : 'Tap the heart on the ones you\u2019d like'));
        var grid = document.createElement('div'); grid.className = 'ph-mgrid';
        var urls = mockups.map(function (m) { return m.url; });
        mockups.forEach(function (m, i) {
          var ch = choices[m.id] && choices[m.id].choice;
          var card = document.createElement('div'); card.className = 'ph-mcard' + (ch ? ' is-' + ch : '');
          var media = document.createElement('div'); media.className = 'ph-mcard-media';
          var img = document.createElement('button'); img.type = 'button'; img.className = 'ph-mcard-img'; img.setAttribute('aria-label', 'Enlarge mockup');
          img.innerHTML = '<img alt="" loading="lazy" src="' + esc(m.url) + '">';
          img.addEventListener('click', function () { lightbox(urls, i); });
          var heart = document.createElement('button'); heart.type = 'button'; heart.className = 'ph-heart' + (ch === 'yes' ? ' is-on' : '');
          heart.innerHTML = icon(IC.heart);
          heart.setAttribute('aria-pressed', ch === 'yes' ? 'true' : 'false');
          heart.setAttribute('aria-label', ch === 'yes' ? 'Remove from wanted' : 'I want this one');
          heart.title = ch === 'yes' ? 'Remove from wanted' : 'I want this one';
          heart.addEventListener('click', function () {
            heart.disabled = true;
            var v = ch === 'yes' ? 'no' : 'yes';
            api('/mockup-choice', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ j: J, t: T, file_id: m.id, choice: v }) }).then(function (r) {
              if (!r.ok || !r.body.success) throw new Error();
              lastSig = ''; load(true);
            }).catch(function () { heart.disabled = false; });
          });
          media.appendChild(img); media.appendChild(heart);
          var info = document.createElement('div'); info.className = 'ph-mcard-info';
          info.innerHTML = '<div style="min-width:0"><div class="ph-mcard-name">' + esc(mockName(m.filename, i)) + '</div><span class="ph-mcard-state">' +
            (ch === 'yes' ? 'You want this one' : ch === 'no' ? 'Not for you' : '') + '</span></div>';
          var ask = document.createElement('button'); ask.type = 'button'; ask.className = 'ph-ask'; ask.textContent = 'Request a change';
          ask.addEventListener('click', function () { if (composer) composer.aboutMode(m); });
          info.appendChild(ask);
          card.appendChild(media); card.appendChild(info); grid.appendChild(card);
        });
        sec.appendChild(grid);
      } else {
        sec.appendChild(secHead('Your mockups', 'See your design on real products before you order'));
        var empty = document.createElement('div'); empty.className = 'ph-empty';
        empty.textContent = requests.length ? 'We\u2019re working on your mockups. We\u2019ll email you when they\u2019re ready.' : 'Choose the products you\u2019d like to see below, and we\u2019ll send mockups.';
        sec.appendChild(empty);
      }
      elFocus.appendChild(sec);

      // 3. Try it on other products
      var rs = document.createElement('section'); rs.className = 'ph-sec';
      var reqBy = {};
      requests.forEach(function (r) { reqBy[String(r.name || '').toLowerCase()] = r; });
      var open = requests.filter(function (r) { return !r.done; });
      rs.appendChild(secHead(mockups.length ? 'Try it on other products' : 'See it on our products',
        open.length ? 'We\u2019re mocking up: ' + open.map(function (r) { return r.name; }).join(', ') : 'Tap any products you\u2019d like to see your design on. Free, no obligation.'));
      var art = designImage();
      var tiles = document.createElement('div'); tiles.className = 'ph-tiles';
      var bar = document.createElement('div'); bar.className = 'ph-rq-bar';
      var cnt = document.createElement('span'); cnt.className = 'ph-rq-count';
      var note = document.createElement('input'); note.type = 'text'; note.className = 'ph-rq-input'; note.placeholder = 'Something else? Type it here'; note.value = rqNoteVal;
      note.setAttribute('aria-label', 'Other products or notes');
      var go = document.createElement('button'); go.type = 'button'; go.className = 'ph-btn ph-btn-sm';
      var err = document.createElement('div'); err.className = 'ph-err'; err.hidden = true;
      function count() { return Object.keys(picked).filter(function (k) { return picked[k]; }).length; }
      function sync() {
        var n = count();
        cnt.textContent = n ? n + ' selected' : '';
        bar.classList.toggle('is-active', n > 0);
        go.disabled = !n && !note.value.trim();
        go.innerHTML = 'Request<span class="ph-hide-sm"> ' + (n > 1 ? n + ' mockups' : 'mockup') + '</span>';
        approveOpen = n > 0 || !!note.value.trim();
      }
      PRODUCTS.forEach(function (pr) {
        var rq = reqBy[pr.name.toLowerCase()];
        var t = document.createElement('button'); t.type = 'button';
        t.className = 'ph-tile' + (picked[pr.name] ? ' is-on' : '') + (rq && rq.done ? ' is-done' : '');
        t.setAttribute('aria-pressed', picked[pr.name] ? 'true' : 'false');
        var media = pr.img ? '<img alt="" loading="lazy" src="' + esc(pr.img) + '">'
          : art ? '<img class="is-art" alt="" loading="lazy" src="' + esc(art.url) + '">'
          : '<b>' + esc(pr.name.charAt(0)) + '</b>';
        var tag = rq ? '<span class="ph-tile-tag">' + (rq.done ? 'Mockup sent' : 'Requested') + '</span>' : '';
        t.innerHTML = '<span class="ph-tile-img">' + media + tag + '<span class="ph-tile-tick">' + icon(IC.check) + '</span></span>' +
          '<span class="ph-tile-name">' + esc(pr.name) + (pr.price ? '<small>' + esc(pr.price) + '</small>' : '') + '</span>';
        var pimg = pr.img && t.querySelector('.ph-tile-img > img');
        if (pimg) pimg.addEventListener('error', function () {
          if (art) { pimg.className = 'is-art'; pimg.src = art.url; } else { pimg.outerHTML = '<b>' + esc(pr.name.charAt(0)) + '</b>'; }
        }, { once: true });
        if (rq && !rq.done) { t.disabled = true; t.title = 'Already requested'; }
        t.addEventListener('click', function () {
          picked[pr.name] = !picked[pr.name];
          t.classList.toggle('is-on', !!picked[pr.name]); t.setAttribute('aria-pressed', picked[pr.name] ? 'true' : 'false');
          sync();
        });
        tiles.appendChild(t);
      });
      note.addEventListener('input', function () { rqNoteVal = note.value; sync(); });
      note.addEventListener('keydown', function (e) { if (e.key === 'Enter' && !go.disabled) go.click(); });
      bar.appendChild(cnt); bar.appendChild(note); bar.appendChild(go);
      rs.appendChild(tiles); rs.appendChild(bar); rs.appendChild(err);
      go.addEventListener('click', function () {
        var items = Object.keys(picked).filter(function (k) { return picked[k]; });
        go.disabled = true; go.textContent = 'Sending'; err.hidden = true;
        api('/mockup-request', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ j: J, t: T, items: items, note: note.value.trim() }) }).then(function (r) {
          if (!r.ok || !r.body.success) throw new Error((r.body && r.body.error) || 'Not sent');
          picked = {}; rqNoteVal = ''; approveOpen = false; lastSig = ''; load(true);
        }).catch(function (e) { err.hidden = false; err.textContent = (e && e.message) || 'Not sent. Please try again.'; sync(); });
      });
      sync();
      if (count() || rqNoteVal) approveOpen = true;
      elFocus.appendChild(rs);

      // 4. Final files
      if (finals.length) {
        var fs = document.createElement('section'); fs.className = 'ph-sec';
        fs.appendChild(secHead('Your final files', 'Print-ready artwork, yours to keep'));
        var list = document.createElement('div'); list.className = 'ph-flist';
        finals.forEach(function (f) {
          var x = document.createElement('a'); x.href = f.url; x.target = '_blank'; x.rel = 'noopener'; x.setAttribute('download', f.filename || '');
          x.innerHTML = '<span class="ph-flist-ext">' + esc(extOf(f.filename || f.url)) + '</span><span class="ph-flist-name">' + esc(f.filename || 'Artwork file') + '</span>' + icon(IC.down);
          list.appendChild(x);
        });
        fs.appendChild(list);
        elFocus.appendChild(fs);
      }
    }

    // Tick "ready for printing", then confirm with your name.
    function buildReady(job, round) {
      var box = document.createElement('div'); box.className = 'ph-ready';
      var ck = document.createElement('label'); ck.className = 'ph-check';
      var tick = document.createElement('input'); tick.type = 'checkbox';
      var txt = document.createElement('span');
      txt.innerHTML = '<strong>This proof is ready for printing</strong><small></small>';
      txt.querySelector('small').textContent = confirmLabel;
      ck.appendChild(tick); ck.appendChild(txt);
      var conf = document.createElement('div'); conf.className = 'ph-ready-confirm'; conf.hidden = true;
      // Name comes from the brief. Only ask if we don't have one on file.
      var known = String(job.contact_name || '').trim();
      var f = document.createElement('label'); f.className = 'ph-field';
      var name = document.createElement('input'); name.type = 'text'; name.autocomplete = 'name'; name.value = known;
      if (known) {
        f = document.createElement('p'); f.className = 'ph-ready-as';
        f.innerHTML = 'Confirming as <strong>' + esc(known) + '</strong>';
      } else {
        f.innerHTML = '<span>Your full name</span>'; f.appendChild(name);
      }
      var go = document.createElement('button'); go.type = 'button'; go.className = 'ph-btn ph-btn-ok';
      var label = icon(IC.print) + 'Confirm, ready for printing';
      go.innerHTML = label;
      var err = document.createElement('div'); err.className = 'ph-err'; err.hidden = true;
      conf.appendChild(f); conf.appendChild(go); conf.appendChild(err);
      box.appendChild(ck); box.appendChild(conf);
      function sync() {
        conf.hidden = !tick.checked; box.classList.toggle('is-on', tick.checked); approveOpen = tick.checked;
        go.disabled = !(tick.checked && name.value.trim());
      }
      tick.addEventListener('change', function () { sync(); if (tick.checked && !known) name.focus(); });
      name.addEventListener('input', sync);
      go.addEventListener('click', function () {
        go.disabled = true; go.textContent = 'Confirming'; err.hidden = true;
        api('/approve', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ j: J, t: T, round_id: round.id, signed_name: name.value.trim(), confirmed: true }) }).then(function (r) {
          if (!r.ok || !r.body.success) throw new Error((r.body && r.body.error) || 'Could not confirm. Please try again.');
          approveOpen = false; lastSig = ''; load();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }).catch(function (e) {
          err.hidden = false; err.textContent = e.message || 'Connection error. Please try again.';
          go.innerHTML = label; sync();
        });
      });
      sync(); approveOpen = false;
      return box;
    }

    /* ---- Brief panel ----------------------------------------------------- */

    function renderBriefPanel(job) {
      var b = job.brief || {};
      var biz = b.business || {}, art = b.art_option || {}, tl = b.timeline || {}, logo = b.logo || {};
      elBrief.innerHTML = '';
      elBrief.className = 'ph-brief' + (briefExpanded ? '' : ' is-collapsed');
      var head = document.createElement('div'); head.className = 'ph-brief-head';
      head.innerHTML = '<h2>Your brief</h2>';
      var edit = document.createElement('button'); edit.type = 'button'; edit.className = 'ph-btn ph-btn-ghost'; edit.innerHTML = icon(IC.edit) + 'Edit';
      edit.addEventListener('click', function () { briefEditing = true; renderBriefEdit(job); });
      head.appendChild(edit); elBrief.appendChild(head);

      var body = document.createElement('div'); body.className = 'ph-brief-body';
      var facts = [];
      if (art.name) facts.push(['Layout', art.name + (b.extra_vehicles && b.extra_vehicles.count ? ' + ' + b.extra_vehicles.count + ' extra' : ''), '']);
      if (b.fees && b.fees.total) facts.push(['Estimate', money(b.fees.total), 'Confirmed before we start']);
      if (tl.deadline) { var n = daysLeft(tl.deadline); facts.push(['Deadline', fmtDeadline(tl.deadline), n == null ? '' : n < 0 ? 'Passed' : n === 0 ? 'Today' : 'In ' + n + ' day' + (n === 1 ? '' : 's'), n != null && n <= 3 ? 'is-soon' : '']); }
      if (logo.choice) facts.push(['Logo', human(logo.choice), '']);
      if (b.copyright_choice) facts.push(['Copyright', human(b.copyright_choice), '']);
      if (biz.home_base) facts.push(['Home base', biz.home_base, '']);
      if (facts.length) {
        var fg = document.createElement('div'); fg.className = 'ph-bfacts';
        facts.forEach(function (f) {
          var d = document.createElement('div'); d.className = 'ph-bfact';
          d.innerHTML = '<span>' + esc(f[0]) + '</span><strong>' + esc(f[1]) + '</strong>' + (f[2] ? '<small class="' + (f[3] || '') + '">' + esc(f[2]) + '</small>' : '');
          fg.appendChild(d);
        });
        body.appendChild(fg);
      }
      var rest = document.createElement('div'); rest.className = 'ph-brief-rest';
      [['Artwork details', b.subject_description], ['Notes', b.notes], ['Freight', biz.freight_type], ['Routes', biz.routes], ['Deadline notes', tl.deadline_notes]].forEach(function (r) {
        if (!r[1]) return;
        var row = document.createElement('div'); row.className = 'ph-brow';
        row.innerHTML = '<span>' + esc(r[0]) + '</span><p></p>'; row.querySelector('p').textContent = r[1];
        rest.appendChild(row);
      });
      var refs = (b.reference_images || []).filter(function (f) { return f && f.url; });
      if (refs.length) {
        var rr = document.createElement('div'); rr.className = 'ph-brow'; rr.innerHTML = '<span>Reference images (' + refs.length + ')</span>';
        rr.appendChild(galleryEl(refs)); rest.appendChild(rr);
      }
      var lf = (logo.files || []).filter(function (f) { return f && f.url; });
      if (lf.length) {
        var lr = document.createElement('div'); lr.className = 'ph-brow'; lr.innerHTML = '<span>Logo files</span>';
        var fl = document.createElement('div'); fl.className = 'ph-files';
        lf.forEach(function (f) { var a = document.createElement('a'); a.href = f.url; a.target = '_blank'; a.rel = 'noopener'; a.innerHTML = icon(IC.clip) + '<span>' + esc(f.filename || 'Logo file') + '</span>'; fl.appendChild(a); });
        lr.appendChild(fl); rest.appendChild(lr);
      }
      var gal = (b.gallery_references || []).map(function (g) { return g && { url: g.image || g.url, filename: g.title || '' }; }).filter(function (g) { return g && g.url; });
      if (gal.length) {
        var gr = document.createElement('div'); gr.className = 'ph-brow'; gr.innerHTML = '<span>Gallery picks</span>';
        gr.appendChild(galleryEl(gal)); rest.appendChild(gr);
      }
      var note = document.createElement('p'); note.className = 'ph-brief-note';
      note.textContent = 'Want to change the layout or logo? Send us a message, as it can change the price.';
      rest.appendChild(note);
      body.appendChild(rest);
      var more = document.createElement('button'); more.type = 'button'; more.className = 'ph-brief-more';
      more.textContent = briefExpanded ? 'Hide full brief' : 'Show full brief';
      more.addEventListener('click', function () { briefExpanded = !briefExpanded; elBrief.classList.toggle('is-collapsed', !briefExpanded); more.textContent = briefExpanded ? 'Hide full brief' : 'Show full brief'; });
      body.appendChild(more);
      elBrief.appendChild(body);
    }

    function renderBriefEdit(job) {
      var b = job.brief || {}, biz = b.business || {}, tl = b.timeline || {};
      elBrief.className = 'ph-brief';
      elBrief.innerHTML = '<div class="ph-brief-head"><h2>Edit your brief</h2></div>';
      var form = document.createElement('div'); form.className = 'ph-brief-body ph-bedit';
      var FIELDS = [
        ['subject_description', 'Artwork details', b.subject_description, 'textarea', 'Trucks, regos, colours, what you want in the picture'],
        ['notes', 'Notes', b.notes, 'textarea', 'Anything else we should know'],
        ['freight_type', 'Freight', biz.freight_type, 'input', ''],
        ['home_base', 'Home base', biz.home_base, 'input', ''],
        ['routes', 'Routes', biz.routes, 'textarea', ''],
        ['deadline', 'Deadline', tl.deadline, 'date', ''],
        ['deadline_notes', 'Deadline notes', tl.deadline_notes, 'input', 'e.g. Needed for the truck show']
      ];
      var inputs = {};
      FIELDS.forEach(function (f) {
        var l = document.createElement('label'); l.innerHTML = '<span>' + esc(f[1]) + '</span>';
        var el = f[3] === 'textarea' ? document.createElement('textarea') : document.createElement('input');
        if (f[3] === 'textarea') el.rows = f[0] === 'routes' ? 2 : 4;
        else el.type = f[3] === 'date' ? 'date' : 'text';
        el.value = f[2] || ''; if (f[4]) el.placeholder = f[4];
        l.appendChild(el); form.appendChild(l); inputs[f[0]] = el;
      });

      var refs = (b.reference_images || []).filter(function (r) { return r && r.url; });
      var removed = {}, newFiles = [];
      var rl = document.createElement('label'); rl.innerHTML = '<span>Reference images</span>';
      var grid = document.createElement('div'); grid.className = 'ph-bedit-refs';
      var picker = document.createElement('input'); picker.type = 'file'; picker.accept = 'image/*'; picker.multiple = true; picker.hidden = true;
      function drawRefs() {
        grid.innerHTML = '';
        refs.forEach(function (r) {
          var c = document.createElement('div'); c.className = 'ph-bedit-ref' + (removed[r.url] ? ' is-removed' : '');
          c.innerHTML = '<img alt="" src="' + esc(r.url) + '">';
          var x = document.createElement('button'); x.type = 'button'; x.textContent = removed[r.url] ? '\u21ba' : '\u00d7'; x.setAttribute('aria-label', removed[r.url] ? 'Keep image' : 'Remove image');
          x.addEventListener('click', function (e) { e.preventDefault(); removed[r.url] = !removed[r.url]; drawRefs(); });
          c.appendChild(x); grid.appendChild(c);
        });
        newFiles.forEach(function (f, i) {
          var c = document.createElement('div'); c.className = 'ph-bedit-ref';
          var im = document.createElement('img'); im.alt = ''; c.appendChild(im);
          var rd = new FileReader(); rd.onload = function (e) { im.src = e.target.result; }; rd.readAsDataURL(f);
          var x = document.createElement('button'); x.type = 'button'; x.textContent = '\u00d7'; x.setAttribute('aria-label', 'Remove image');
          x.addEventListener('click', function (e) { e.preventDefault(); newFiles.splice(i, 1); drawRefs(); });
          c.appendChild(x); grid.appendChild(c);
        });
        var add = document.createElement('button'); add.type = 'button'; add.className = 'ph-bedit-add'; add.textContent = '+ Add images';
        add.addEventListener('click', function (e) { e.preventDefault(); picker.click(); });
        grid.appendChild(add);
      }
      picker.addEventListener('change', function () { for (var i = 0; i < this.files.length; i++) if (this.files[i].type.indexOf('image/') === 0) newFiles.push(this.files[i]); this.value = ''; drawRefs(); });
      drawRefs();
      rl.appendChild(grid); rl.appendChild(picker); form.appendChild(rl);

      var foot = document.createElement('div'); foot.className = 'ph-bedit-foot';
      var cancel = document.createElement('button'); cancel.type = 'button'; cancel.className = 'ph-btn ph-btn-ghost'; cancel.textContent = 'Cancel';
      var save = document.createElement('button'); save.type = 'button'; save.className = 'ph-btn'; save.textContent = 'Save changes';
      foot.appendChild(cancel); foot.appendChild(save);
      var err = document.createElement('div'); err.className = 'ph-err'; err.hidden = true;
      form.appendChild(foot); form.appendChild(err);
      elBrief.appendChild(form);
      elBrief.scrollIntoView({ behavior: 'smooth', block: 'start' });

      cancel.addEventListener('click', function () { briefEditing = false; renderBriefPanel(job); });
      save.addEventListener('click', function () {
        var changes = {};
        FIELDS.forEach(function (f) { var v = inputs[f[0]].value.trim(); if (v !== String(f[2] || '').trim()) changes[f[0]] = v; });
        var rm = Object.keys(removed).filter(function (u) { return removed[u]; });
        if (rm.length) changes.remove_references = rm;
        if (!Object.keys(changes).length && !newFiles.length) { briefEditing = false; renderBriefPanel(job); return; }
        save.disabled = true; cancel.disabled = true; save.textContent = newFiles.length ? 'Uploading' : 'Saving'; err.hidden = true;
        Promise.all(newFiles.map(function (f) {
          var fd = new FormData(); fd.append('file', f, f.name);
          return fetch(workerUrl + '/upload', { method: 'POST', body: fd }).then(function (r) { return r.json(); }).then(function (x) {
            if (!x || !x.success || !x.url) throw new Error('Image upload failed');
            return { url: x.url, filename: f.name };
          });
        })).then(function (added) {
          if (added.length) changes.add_references = added;
          save.textContent = 'Saving';
          return api('/brief', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ j: J, t: T, changes: changes }) });
        }).then(function (r) {
          if (!r.ok || !r.body.success) throw new Error((r.body && r.body.error) || 'Could not save');
          job.brief = r.body.brief; briefEditing = false; briefExpanded = true;
          renderBriefPanel(job);
          lastSig = ''; load(true);
        }).catch(function (e) {
          save.disabled = false; cancel.disabled = false; save.textContent = 'Save changes';
          err.hidden = false; err.textContent = (e && e.message) || 'Connection error. Please try again.';
        });
      });
    }

    function renderLog(job, rounds, chat) {
      var events = [];
      function ts(s) { var d = toDate(s); return d ? d.getTime() : 0; }
      chat.forEach(function (c) { events.push({ t: ts(c.created_at), type: 'msg', c: c }); });
      rounds.forEach(function (r) {
        events.push({ t: ts(r.created_at), type: 'proof', r: r });
        (r.comments || []).forEach(function (c) { events.push({ t: ts(c.created_at), type: 'msg', c: c }); });
        if (r.approval) events.push({ t: ts(r.approval.approved_at), type: 'approval', r: r });
      });
      events.sort(function (a, b) { return a.t - b.t; });
      elLog.innerHTML = '';
      if (!events.length) { elLog.innerHTML = '<div class="ph-log-empty">No messages yet. Say hello or ask us anything below.</div>'; return; }
      var lastDay = '';
      events.forEach(function (e) {
        var d = e.t ? new Date(e.t) : null;
        var day = d ? fmtDay(d) : '';
        if (day && day !== lastDay) { var sep = document.createElement('div'); sep.className = 'ph-day'; sep.textContent = day; elLog.appendChild(sep); lastDay = day; }
        var time = d ? fmtTime(d) : '';
        if (e.type === 'msg') {
          var me = e.c.author !== 'lid';
          var pb = parseBody(e.c.body);
          var el = document.createElement('div'); el.className = 'ph-msg' + (me ? ' is-me' : '');
          el.innerHTML = '<div class="ph-msg-meta"><strong>' + (me ? 'You' : 'Lucky Inger') + '</strong>' + esc(time) + '</div>' + (pb.text ? '<div class="ph-msg-body"></div>' : '');
          if (pb.text) el.querySelector('.ph-msg-body').textContent = pb.text;
          if (pb.files.length) el.appendChild(attEl(pb.files));
          elLog.appendChild(el);
        } else if (e.type === 'proof') {
          var r = e.r;
          var st = r.status === 'approved' ? 'approved' : r.status === 'changes_requested' ? 'changes_requested' : 'proof_sent';
          var lbl = st === 'approved' ? 'Approved' : st === 'changes_requested' ? 'Changes requested' : 'Ready for review';
          var card = document.createElement('div'); card.className = 'ph-proof';
          card.innerHTML = '<div class="ph-proof-head"><strong>Round ' + esc(r.round_number) + ' proof</strong><span class="ph-st st-' + st + '">' + lbl + '</span><time>' + esc(time) + '</time></div>';
          if (r.note) { var p = document.createElement('p'); p.textContent = r.note; card.appendChild(p); }
          if (r.files && r.files.length) card.appendChild(galleryEl(r.files));
          elLog.appendChild(card);
        } else {
          var s = document.createElement('div'); s.className = 'ph-sys';
          s.innerHTML = icon(IC.check) + '<span>' + esc(e.r.approval.signed_name) + ' approved round ' + esc(e.r.round_number) + ' &middot; ' + esc(time) + '</span>';
          elLog.appendChild(s);
        }
      });
    }

    function attEl(files) {
      var w = document.createElement('div'); w.className = 'ph-att';
      var imgs = files.filter(function (f) { return isImg(f.filename) || isImg(f.url); });
      var urls = imgs.map(function (f) { return f.url; });
      files.forEach(function (f) {
        if (urls.indexOf(f.url) !== -1) {
          var b = document.createElement('button'); b.type = 'button'; b.className = 'ph-att-img'; b.setAttribute('aria-label', 'Enlarge ' + f.filename);
          var im = document.createElement('img'); im.src = f.url; im.alt = f.filename; im.loading = 'lazy'; b.appendChild(im);
          b.addEventListener('click', function () { lightbox(urls, urls.indexOf(f.url)); });
          w.appendChild(b);
        } else {
          var a = document.createElement('a'); a.className = 'ph-att-file'; a.href = f.url; a.target = '_blank'; a.rel = 'noopener';
          a.innerHTML = icon(IC.clip) + '<span>' + esc(f.filename) + '</span>';
          w.appendChild(a);
        }
      });
      return w;
    }

    /* ---- Composer -------------------------------------------------------- */

    function buildComposer(job) {
      var box = document.createElement('div'); box.className = 'ph-composer';
      var mode = document.createElement('div'); mode.className = 'ph-mode'; mode.hidden = true;
      var modeTxt = document.createElement('span');
      var modeX = document.createElement('button'); modeX.type = 'button'; modeX.textContent = 'Cancel';
      mode.appendChild(modeTxt); mode.appendChild(modeX);
      var previews = document.createElement('div'); previews.className = 'ph-previews';
      var row = document.createElement('div'); row.className = 'ph-composer-row';
      var attach = document.createElement('button'); attach.type = 'button'; attach.className = 'ph-icon-btn'; attach.setAttribute('aria-label', 'Attach a photo or file'); attach.title = 'Attach a photo or file'; attach.innerHTML = icon(IC.clip);
      var file = document.createElement('input'); file.type = 'file'; file.multiple = true; file.hidden = true;
      var ta = document.createElement('textarea'); ta.className = 'ph-input'; ta.rows = 1; ta.placeholder = 'Write a message\u2026';
      var send = document.createElement('button'); send.type = 'button'; send.className = 'ph-btn ph-send'; send.setAttribute('aria-label', 'Send'); send.innerHTML = icon(IC.send);
      row.appendChild(attach); row.appendChild(file); row.appendChild(ta); row.appendChild(send);
      var note = document.createElement('div'); note.className = 'ph-composer-note'; note.hidden = true;
      box.appendChild(mode); box.appendChild(previews); box.appendChild(row); box.appendChild(note);

      var files = [], changesRound = 0;
      var api_ = { el: box, busy: false };
      api_.dirty = function () { return !!ta.value.trim() || files.length > 0; };
      api_.changesMode = function (n) {
        changesRound = n;
        box.classList.add('is-changes'); mode.hidden = false;
        modeTxt.textContent = 'Requesting changes to round ' + n + '. Tell us what to change.';
        ta.placeholder = 'e.g. Make the logo bigger, change the trailer to white\u2026';
        box.scrollIntoView({ behavior: 'smooth', block: 'end' });
        setTimeout(function () { ta.focus(); }, 300);
      };
      var aboutFile = null;
      api_.aboutMode = function (m) {
        clearMode(); aboutFile = { url: m.url, filename: m.filename || 'mockup' };
        box.classList.add('is-changes'); mode.hidden = false;
        modeTxt.textContent = 'About mockup: ' + aboutFile.filename + '. What would you like changed, or which variant?';
        ta.placeholder = 'e.g. Same but on a white cap, or bigger on the back\u2026';
        box.scrollIntoView({ behavior: 'smooth', block: 'end' });
        setTimeout(function () { ta.focus(); }, 300);
      };
      function clearMode() { changesRound = 0; aboutFile = null; box.classList.remove('is-changes'); mode.hidden = true; ta.placeholder = 'Write a message\u2026'; }
      modeX.addEventListener('click', clearMode);

      function refresh() {
        previews.innerHTML = '';
        files.forEach(function (f, i) {
          var c = document.createElement('div'); c.className = 'ph-prev';
          if (f.type && f.type.indexOf('image/') === 0) {
            var im = document.createElement('img'); im.alt = ''; c.appendChild(im);
            var rd = new FileReader(); rd.onload = function (e) { im.src = e.target.result; }; rd.readAsDataURL(f);
          } else c.appendChild(document.createTextNode(extOf(f.name)));
          var x = document.createElement('button'); x.type = 'button'; x.textContent = '\u00d7'; x.setAttribute('aria-label', 'Remove');
          x.addEventListener('click', function () { files.splice(i, 1); refresh(); });
          c.appendChild(x); previews.appendChild(c);
        });
        send.disabled = api_.busy || (!files.length && !ta.value.trim());
      }
      function grow() { ta.style.height = 'auto'; ta.style.height = Math.min(ta.scrollHeight, 200) + 'px'; }
      function say(text, kind) { note.hidden = !text; note.textContent = text || ''; note.className = 'ph-composer-note' + (kind ? ' is-' + kind : ''); }
      attach.addEventListener('click', function () { file.click(); });
      file.addEventListener('change', function () { for (var i = 0; i < this.files.length && files.length < 10; i++) files.push(this.files[i]); this.value = ''; refresh(); });
      ta.addEventListener('input', function () { grow(); refresh(); });
      ta.addEventListener('keydown', function (e) {
        // Desktop: Enter sends. Phones: Enter is a new line, tap the send button.
        if (e.key === 'Enter' && !e.shiftKey && !e.isComposing && window.matchMedia('(hover: hover)').matches) { e.preventDefault(); if (!send.disabled) send.click(); }
      });

      function upload(f) {
        var fd = new FormData(); fd.append('file', f, f.name);
        return fetch(workerUrl + '/upload', { method: 'POST', body: fd }).then(function (r) { return r.json(); }).then(function (b) {
          if (!b || !b.success || !b.url) throw new Error('Upload failed');
          return { url: b.url, filename: f.name };
        });
      }
      send.addEventListener('click', function () {
        var text = ta.value.trim();
        if (!text && !files.length) return;
        api_.busy = true; refresh(); say(files.length ? 'Uploading\u2026' : '');
        // Show it in the chat straight away, then swap for the saved copy.
        var empty = elLog.querySelector('.ph-log-empty'); if (empty) empty.remove();
        var pending = document.createElement('div'); pending.className = 'ph-msg is-me is-pending';
        pending.innerHTML = '<div class="ph-msg-meta"><strong>You</strong>Sending\u2026</div>' + (text ? '<div class="ph-msg-body"></div>' : '') + (files.length ? '<div class="ph-msg-meta">' + files.length + ' attachment' + (files.length !== 1 ? 's' : '') + '</div>' : '');
        if (text) pending.querySelector('.ph-msg-body').textContent = text;
        elLog.appendChild(pending);
        var sentText = text; ta.value = ''; grow();
        box.scrollIntoView({ block: 'end' });
        Promise.all(files.map(upload)).then(function (atts) {
          if (aboutFile) atts = [aboutFile].concat(atts);
          return api('/comment', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ j: J, t: T, round_id: 'chat', body: aboutFile ? 'Change request for this mockup: ' + text : text, attachments: atts, author_name: job.contact_name || '', request_changes: !!changesRound }) });
        }).then(function (r) {
          if (!r.ok || !r.body.success) throw new Error((r.body && r.body.error) || 'Not sent');
          var wasChanges = !!changesRound;
          files.length = 0; clearMode();
          say(wasChanges ? 'Sent. We\u2019ll get started on your changes.' : 'Sent. We\u2019ll get back to you soon.', 'ok');
          setTimeout(function () { say(''); }, 5000);
          api_.busy = false; refresh();
          lastSig = ''; load(true).then(function () { box.scrollIntoView({ block: 'end' }); });
        }).catch(function (e) {
          pending.remove(); ta.value = sentText; grow();
          api_.busy = false; refresh();
          say('Not sent: ' + (e.message || 'connection error') + '. Please try again.', 'err');
        });
      });
      refresh();
      return api_;
    }

    /* ---- Lightbox -------------------------------------------------------- */

    function lightbox(urls, start) {
      var i = start || 0;
      var lb = document.createElement('div'); lb.className = 'ph-lb'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true');
      lb.innerHTML = '<div class="ph-lb-bar"><span class="ph-lb-count"></span><span><a class="ph-lb-open" target="_blank" rel="noopener">Open full size</a></span></div><div class="ph-lb-stage"><img alt=""></div>';
      var close = document.createElement('button'); close.type = 'button'; close.className = 'ph-icon-btn'; close.setAttribute('aria-label', 'Close'); close.innerHTML = icon(IC.x);
      lb.firstChild.lastChild.appendChild(close);
      var img = lb.querySelector('img'), count = lb.querySelector('.ph-lb-count'), open = lb.querySelector('.ph-lb-open');
      var prev, next;
      if (urls.length > 1) {
        prev = document.createElement('button'); prev.type = 'button'; prev.className = 'ph-lb-nav ph-lb-prev'; prev.textContent = '\u2039'; prev.setAttribute('aria-label', 'Previous');
        next = document.createElement('button'); next.type = 'button'; next.className = 'ph-lb-nav ph-lb-next'; next.textContent = '\u203a'; next.setAttribute('aria-label', 'Next');
        lb.appendChild(prev); lb.appendChild(next);
        prev.addEventListener('click', function () { go(-1); }); next.addEventListener('click', function () { go(1); });
      }
      function show() { img.src = urls[i]; open.href = urls[i]; count.textContent = urls.length > 1 ? (i + 1) + ' of ' + urls.length : ''; }
      function go(d) { i = (i + d + urls.length) % urls.length; show(); }
      function shut() { lb.remove(); document.documentElement.classList.remove('ph-noscroll'); document.removeEventListener('keydown', key); }
      function key(e) { if (e.key === 'Escape') shut(); else if (e.key === 'ArrowLeft' && urls.length > 1) go(-1); else if (e.key === 'ArrowRight' && urls.length > 1) go(1); }
      close.addEventListener('click', shut);
      lb.querySelector('.ph-lb-stage').addEventListener('click', function (e) { if (e.target !== img) shut(); });
      var sx = null;
      lb.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      lb.addEventListener('touchend', function (e) { if (sx == null || urls.length < 2) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 50) go(dx < 0 ? 1 : -1); sx = null; });
      document.addEventListener('keydown', key);
      wrap.appendChild(lb); document.documentElement.classList.add('ph-noscroll'); show();
    }

    load();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["artwork-proof-studio"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var wrap = document.querySelector('.ps-wrap');
    if (!wrap || !wrap.dataset.workerUrl) return;
    var workerUrl = (wrap.dataset.workerUrl || '').replace(/\/+$/, '');
    var hubUrl = (wrap.dataset.hubUrl || '').replace(/\/+$/, '');
    var pageKey = wrap.dataset.pageKey || '';
    var customerEmail = wrap.dataset.customerEmail || '';
    var customerId = wrap.dataset.customerId || '';

    var elAuthBlock = document.getElementById('ps-authblock');
    var elAuthTitle = document.getElementById('ps-authblock-title');
    var elAuthMsg = document.getElementById('ps-authblock-msg');
    var elRetry = document.getElementById('ps-retry');
    var elApp = document.getElementById('ps-app');
    var elList = document.getElementById('ps-list');
    var elDetail = document.getElementById('ps-detail');
    var elSearch = document.getElementById('ps-search');
    var elFilter = document.getElementById('ps-filter');
    var elRefresh = document.getElementById('ps-refresh');
    var emptyPaneHtml = elDetail ? elDetail.innerHTML : '';

    /* ---- Helpers --------------------------------------------------------- */

    function show(el) { if (el) el.hidden = false; }
    function hide(el) { if (el) el.hidden = true; }
    function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;'); }
    function toDate(s) { if (!s) return null; var iso = /\dT/.test(s) ? s : String(s).replace(' ', 'T') + 'Z'; var d = new Date(iso); return isNaN(d) ? null : d; }
    function fmtDate(s) { var d = toDate(s); return d ? d.toLocaleString('en-AU', { day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit' }) : (s || ''); }
    function fmtDay(s) { var d = toDate(s); return d ? d.toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' }) : (s || ''); }
    function ago(s) {
      var d = toDate(s); if (!d) return '';
      var m = Math.round((Date.now() - d.getTime()) / 60000);
      if (m < 1) return 'now'; if (m < 60) return m + 'm';
      var h = Math.round(m / 60); if (h < 24) return h + 'h';
      var dd = Math.round(h / 24); if (dd < 7) return dd + 'd';
      return d.toLocaleDateString('en-AU', { day: 'numeric', month: 'short' });
    }
    function briefOf(job) { try { return job.brief_json ? JSON.parse(job.brief_json) : null; } catch (e) { return null; } }
    function initials(s) { var w = String(s || '').replace(/[^a-zA-Z0-9 ]/g, ' ').trim().split(/\s+/); return ((w[0] || '?').charAt(0) + (w[1] || '').charAt(0)).toUpperCase(); }
    function isMobile() { return window.matchMedia('(max-width: 900px)').matches; }
    // "Mulgoa Excavations - artwork" displays as "Mulgoa Excavations"
    function jobName(job) { return String(job.title || 'Untitled job').replace(/\s*[-\u2013\u2014]\s*artwork\s*$/i, '') || job.title; }
    function human(v) {
      var s = String(v == null ? '' : v).trim();
      if (/^[a-z0-9]+(_[a-z0-9]+)+$/i.test(s)) { s = s.replace(/_/g, ' '); s = s.charAt(0).toUpperCase() + s.slice(1); }
      return s;
    }
    function parseDeadline(v) { var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(v || '').trim()); return m ? new Date(+m[1], +m[2] - 1, +m[3]) : null; }
    function fmtDeadline(v) { var d = parseDeadline(v); return d ? d.toLocaleDateString('en-AU', { weekday: 'short', day: 'numeric', month: 'short' }) : String(v || ''); }
    function daysLeft(v) { var d = parseDeadline(v); if (!d) return null; var t = new Date(); t.setHours(0, 0, 0, 0); return Math.round((d - t) / 86400000); }
    function dueInfo(v) {
      var n = daysLeft(v);
      if (n == null) return { text: '', cls: '' };
      if (n < 0) return { text: (-n) + ' day' + (n === -1 ? '' : 's') + ' overdue', cls: 'is-late' };
      if (n === 0) return { text: 'Due today', cls: 'is-soon' };
      return { text: 'In ' + n + ' day' + (n === 1 ? '' : 's'), cls: n <= 3 ? 'is-soon' : '' };
    }
    function isImageName(n) { return /\.(png|jpe?g|gif|webp|avif|svg)(\?|$)/i.test(String(n || '')); }
    function extOf(n) { var m = /\.([a-z0-9]{1,5})(\?|$)/i.exec(String(n || '')); return m ? m[1].toUpperCase() : 'FILE'; }

    var STATUS_LABEL = { brief_received: 'Brief received', in_design: 'In design', proof_sent: 'Proof sent', changes_requested: 'Changes requested', approved: 'Approved', archived: 'Archived' };
    var STATUS_OPTS = ['brief_received', 'in_design', 'proof_sent', 'changes_requested', 'approved', 'archived'];
    var FILTERS = ['active', 'brief_received', 'in_design', 'proof_sent', 'changes_requested', 'approved', 'archived', 'all'];
    var FILTER_LABEL = { active: 'Active', all: 'All', brief_received: 'New', in_design: 'In design', proof_sent: 'Sent', changes_requested: 'Changes', approved: 'Approved', archived: 'Archived' };
    function statusHtml(st) { return '<span class="ps-st st-' + esc(st) + '">' + esc(STATUS_LABEL[st] || st) + '</span>'; }

    function icon(d) { return '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="' + d + '" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>'; }
    var IC = {
      send: 'M3 10l14-7-5 14-2.5-5.5z M9.5 11.5L17 3',
      down: 'M10 3v10 M5.5 9l4.5 4.5L14.5 9 M4 17h12',
      link: 'M8.5 11.5a3.5 3.5 0 0 0 5 0l2.5-2.5a3.5 3.5 0 0 0-5-5l-1 1 M11.5 8.5a3.5 3.5 0 0 0-5 0L4 11a3.5 3.5 0 0 0 5 5l1-1',
      check: 'M4 10.5l4 4 8-9',
      trash: 'M4 6h12 M8 6V4h4v2 M6 6l1 11h6l1-11',
      open: 'M11 3h6v6 M17 3l-8 8 M14 12v4H4V6h4',
      copy: 'M7 7h9v9H7z M4 13V4h9',
      mail: 'M3 5h14v10H3z M3 5l7 6 7-6',
      upload: 'M10 14V4 M5.5 8.5L10 4l4.5 4.5 M4 16h12',
      folder: 'M2.5 5.5h5l1.5 2h8.5v8.5h-15z',
      clip: 'M15.5 9.5l-5.8 5.8a3.5 3.5 0 0 1-5-5L11 4a2.3 2.3 0 0 1 3.3 3.3l-6.2 6.2a1.2 1.2 0 0 1-1.7-1.7L12 6.2',
      x: 'M5 5l10 10 M15 5L5 15'
    };

    function copyText(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(text);
      return new Promise(function (resolve) {
        var t = document.createElement('textarea'); t.value = text; document.body.appendChild(t); t.select();
        try { document.execCommand('copy'); } catch (e) {} document.body.removeChild(t); resolve();
      });
    }

    // Deep link: ?job=<id> opens that job.
    var pendingJobId = '';
    try { pendingJobId = new URLSearchParams(window.location.search).get('job') || ''; } catch (e) {}
    function setJobParam(id) {
      try {
        var u = new URL(window.location.href);
        if (id) u.searchParams.set('job', id); else u.searchParams.delete('job');
        window.history.replaceState(null, '', u.pathname + (u.search || '') + u.hash);
      } catch (e) {}
    }

    var staffToken = '';
    var allJobs = [];
    var selectedId = '';
    var openSeq = 0;
    var lastJobSig = '';
    function jobSig(b) { return JSON.stringify([b && b.rounds, b && b.chat, b && b.job && b.job.status]); }

    /* Live updates: re-check the open job every 5s and the job list every 30s.
       Skips while you're typing, uploading, or have a menu/window open. */
    function busyUi() {
      if (document.hidden || openMenu || document.getElementById('ps-modal')) return true;
      var ta = elDetail && elDetail.querySelector('.ps-composer-input');
      if (ta && ta.value.trim()) return true;
      if (elDetail && elDetail.querySelector('.ps-composer .ps-prev, .ps-composer .ps-btn:disabled[data-busy]')) return true;
      return false;
    }
    setInterval(function () {
      if (!staffToken || !selectedId || busyUi()) return;
      var job = findJob(selectedId); if (!job) return;
      var seq = openSeq;
      pubFetch('/job?j=' + encodeURIComponent(job.id) + '&t=' + encodeURIComponent(job.access_token)).then(function (r) {
        if (seq !== openSeq || selectedId !== job.id || busyUi() || !r.body || !r.body.success) return;
        var sig = jobSig(r.body);
        if (sig === lastJobSig) return;
        lastJobSig = sig;
        if (r.body.job && r.body.job.status) job.status = r.body.job.status;
        var hadFocus = document.activeElement && document.activeElement.classList.contains('ps-composer-input');
        renderJob(job, r.body.rounds || [], r.body.chat || []);
        if (hadFocus) { var t = elDetail.querySelector('.ps-composer-input'); if (t) t.focus(); }
      }).catch(function () {});
    }, 5000);
    /* Email replies: ask the Worker to pull any new replies from Resend.
       Runs on load and every 20s while the studio is open. */
    var syncBusy = false;
    function syncReplies() {
      if (!staffToken || syncBusy || document.hidden) return;
      syncBusy = true;
      adminFetch('/admin/inbound-sync', { method: 'POST' }).then(function (r) {
        syncBusy = false;
        var note = document.getElementById('ps-sync-note');
        var b = r.body || {};
        if (note) {
          if (b.success === false && b.error) { note.hidden = false; note.textContent = 'Email replies not syncing: ' + b.error; }
          else note.hidden = true;
        }
        if (b.imported) {
          adminFetch('/admin/jobs').then(function (x) { if (x.ok && x.body && x.body.success) { allJobs = x.body.jobs || []; renderList(); } });
        }
      }).catch(function () { syncBusy = false; });
    }
    setInterval(syncReplies, 20000);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) syncReplies(); });

    setInterval(function () {
      if (!staffToken || document.hidden) return;
      var before = JSON.stringify(allJobs.map(function (j) { return [j.id, j.status, j.updated_at]; }));
      adminFetch('/admin/jobs').then(function (r) {
        if (!r.ok || !r.body || !r.body.success) return;
        var next = r.body.jobs || [];
        if (JSON.stringify(next.map(function (j) { return [j.id, j.status, j.updated_at]; })) === before) return;
        // Keep brief/status fresh on the open job too.
        allJobs = next; renderList();
      }).catch(function () {});
    }, 30000);
    var currentTab = '';
    var currentTabJob = '';

    /* ---- Auth ------------------------------------------------------------ */

    function showAuthState(title, message, isErr) {
      hide(elApp);
      if (!elAuthBlock) return;
      elAuthBlock.classList.toggle('is-err', !!isErr);
      if (elAuthTitle) elAuthTitle.textContent = title;
      if (elAuthMsg) elAuthMsg.textContent = message;
      if (elRetry) elRetry.hidden = !isErr;
      show(elAuthBlock);
    }
    function showAuthError(title, message) { showAuthState(title, message, true); }

    function loginToWorker() {
      return fetch(workerUrl + '/staff/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ page_key: pageKey, email: customerEmail, customer_id: customerId })
      }).then(function (res) {
        return res.json().then(function (b) { return { ok: res.ok, status: res.status, body: b }; });
      }).then(function (r) {
        if (r.ok && r.body && r.body.success && r.body.token) { staffToken = r.body.token; return true; }
        throw new Error((r.body && r.body.error) || ('HTTP ' + r.status));
      });
    }
    if (elRetry) elRetry.addEventListener('click', function () { boot(); });

    function adminFetch(path, opts) {
      opts = opts || {}; opts.headers = opts.headers || {};
      opts.headers['x-staff-token'] = staffToken;
      return fetch(workerUrl + path, opts).then(function (res) {
        return res.json().then(function (b) { return { ok: res.ok, status: res.status, body: b }; });
      }).then(function (r) {
        if (r.status === 401 && staffToken) {
          return loginToWorker().then(function () {
            opts.headers['x-staff-token'] = staffToken;
            return fetch(workerUrl + path, opts).then(function (res2) {
              return res2.json().then(function (b2) { return { ok: res2.ok, status: res2.status, body: b2 }; });
            });
          });
        }
        return r;
      });
    }
    function pubFetch(path) {
      return fetch(workerUrl + path).then(function (res) {
        return res.json().then(function (b) { return { ok: res.ok, status: res.status, body: b }; });
      });
    }

    /* ---- Job list -------------------------------------------------------- */

    function loadJobs(quiet) {
      if (!quiet) showAuthState('Loading jobs', 'One moment.', false);
      if (elRefresh) elRefresh.classList.add('is-spin');
      return adminFetch('/admin/jobs').then(function (r) {
        if (elRefresh) elRefresh.classList.remove('is-spin');
        if (!r.ok || !r.body || !r.body.success) { showAuthError('Session ended', 'Please refresh the page to sign in again.'); return; }
        allJobs = r.body.jobs || [];
        hide(elAuthBlock); show(elApp);
        if (pendingJobId) {
          var wanted = pendingJobId; pendingJobId = '';
          var match = findJob(wanted);
          if (match) { if (!matchesFilter(match, elFilter.value)) elFilter.value = 'all'; renderList(); openJob(match); return; }
          setJobParam('');
        }
        renderList();
        if (selectedId && !findJob(selectedId)) clearPane();
      }).catch(function () {
        if (elRefresh) elRefresh.classList.remove('is-spin');
        showAuthError('Connection error', 'Could not reach the server. Check your internet and try again.');
      });
    }

    function findJob(id) { return allJobs.filter(function (j) { return j.id === id; })[0] || null; }
    function matchesFilter(j, f) {
      if (f === 'all') return true;
      if (f === 'active') return j.status !== 'approved' && j.status !== 'archived';
      return j.status === f;
    }

    function renderFilters() {
      var el = document.getElementById('ps-tabs'); if (!el) return;
      var f = elFilter.value;
      el.innerHTML = '';
      FILTERS.forEach(function (key) {
        var n = allJobs.filter(function (j) { return matchesFilter(j, key); }).length;
        if (!n && key !== 'active' && key !== 'all' && key !== f) return;
        var b = document.createElement('button'); b.type = 'button'; b.setAttribute('role', 'tab');
        b.className = key === f ? 'is-on' : '';
        b.setAttribute('aria-selected', key === f ? 'true' : 'false');
        b.innerHTML = esc(FILTER_LABEL[key] || key) + ' <em>' + n + '</em>';
        b.addEventListener('click', function () { elFilter.value = key; renderList(); });
        el.appendChild(b);
      });
    }

    function renderList() {
      renderFilters();
      var q = (elSearch.value || '').toLowerCase().trim();
      var f = elFilter.value;
      var jobs = allJobs.filter(function (j) {
        if (!matchesFilter(j, f)) return false;
        if (q && [j.title, j.customer_email, j.contact_name, j.id].join(' ').toLowerCase().indexOf(q) === -1) return false;
        return true;
      });
      elList.innerHTML = '';
      if (!jobs.length) { elList.innerHTML = '<div class="ps-list-empty">' + (q ? 'No jobs match that search.' : 'No jobs here.') + '</div>'; return; }
      jobs.forEach(function (job) {
        var b = briefOf(job) || {};
        var thumbSrc = (b.reference_images && b.reference_images[0] && b.reference_images[0].url) ||
          (b.gallery_references && b.gallery_references[0] && (b.gallery_references[0].image || b.gallery_references[0].url)) || '';
        var due = b.timeline && b.timeline.deadline ? dueInfo(b.timeline.deadline) : null;
        var row = document.createElement('div');
        row.className = 'ps-row' + (job.id === selectedId ? ' is-sel' : '');
        row.setAttribute('role', 'button'); row.tabIndex = 0; row.dataset.id = job.id;
        row.innerHTML =
          '<div class="ps-thumb">' + (thumbSrc ? '<img src="' + esc(thumbSrc) + '" alt="" loading="lazy">' : esc(initials(jobName(job)))) + '</div>' +
          '<div class="ps-row-body">' +
            '<div class="ps-row-l1"><span class="ps-row-title">' + esc(jobName(job)) + '</span><span class="ps-row-time" title="' + esc(fmtDate(job.updated_at)) + '">' + esc(ago(job.updated_at)) + '</span></div>' +
            '<div class="ps-row-l2">' + esc(job.contact_name || job.customer_email || 'No contact') + '</div>' +
            '<div class="ps-row-l3">' + statusHtml(job.status) +
              (due ? '<span class="ps-row-due ' + due.cls + '">Due ' + esc(fmtDeadline(b.timeline.deadline)) + '</span>' : '') +
            '</div>' +
          '</div>';
        var img = row.querySelector('.ps-thumb img');
        if (img) img.addEventListener('error', function () { img.parentNode.textContent = initials(jobName(job)); });
        row.addEventListener('click', function () { openJob(job); });
        row.addEventListener('keydown', function (e) {
          if (e.target !== row) return;
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openJob(job); }
          else if (e.key === 'ArrowDown' && row.nextElementSibling) { e.preventDefault(); row.nextElementSibling.focus(); }
          else if (e.key === 'ArrowUp' && row.previousElementSibling) { e.preventDefault(); row.previousElementSibling.focus(); }
        });
        elList.appendChild(row);
      });
    }

    function markSelected() {
      Array.prototype.forEach.call(elList.querySelectorAll('.ps-row'), function (r) { r.classList.toggle('is-sel', r.dataset.id === selectedId); });
    }
    function clearPane() {
      selectedId = ''; setJobParam('');
      elDetail.innerHTML = emptyPaneHtml;
      elApp.classList.remove('is-detail');
      markSelected();
    }

    if (elSearch) elSearch.addEventListener('input', renderList);
    if (elFilter) elFilter.addEventListener('change', renderList);
    if (elRefresh) elRefresh.addEventListener('click', function () {
      loadJobs(true).then(function () { var j = selectedId && findJob(selectedId); if (j) openJob(j, true); });
    });
    var backBtn = document.getElementById('ps-back');
    if (backBtn) backBtn.addEventListener('click', function () { clearPane(); renderList(); window.scrollTo({ top: 0 }); });

    function deleteJob(job) {
      var name = jobName(job);
      if (!window.confirm('Delete "' + name + '"?\n\nThis permanently removes the request, all proofs, comments and uploaded files. It cannot be undone.')) return;
      var row = elList.querySelector('.ps-row[data-id="' + job.id + '"]');
      if (row) row.classList.add('is-deleting');
      adminFetch('/admin/job-delete', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ job_id: job.id }) }).then(function (r) {
        if (!r.ok || !r.body || !r.body.success) throw new Error((r.body && r.body.error) || ('HTTP ' + r.status));
        allJobs = allJobs.filter(function (j) { return j.id !== job.id; });
        if (selectedId === job.id) clearPane();
        renderList();
      }).catch(function (err) {
        if (row) row.classList.remove('is-deleting');
        window.alert('Delete failed: ' + ((err && err.message) || 'connection error'));
      });
    }

    /* ---- Files + Download all (zip) -------------------------------------- */

    var JSZIP_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/jszip/3.10.1/jszip.min.js';
    var jszipPromise = null;
    function loadJSZip() {
      if (window.JSZip) return Promise.resolve(window.JSZip);
      if (jszipPromise) return jszipPromise;
      jszipPromise = new Promise(function (resolve, reject) {
        var s = document.createElement('script'); s.src = JSZIP_SRC; s.async = true;
        s.onload = function () { window.JSZip ? resolve(window.JSZip) : reject(new Error('Zip library failed to load')); };
        s.onerror = function () { jszipPromise = null; reject(new Error('Zip library failed to load')); };
        document.head.appendChild(s);
      });
      return jszipPromise;
    }
    function slug(s) { return String(s || '').replace(/[^a-zA-Z0-9._-]+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '').slice(0, 60) || 'file'; }
    function absUrl(u) { u = String(u || ''); return u.indexOf('//') === 0 ? 'https:' + u : u; }
    function nameFromUrl(u) { try { var p = new URL(absUrl(u)).pathname.split('/').pop(); return decodeURIComponent(p || ''); } catch (e) { return ''; } }

    function collectFiles(job, rounds) {
      var list = [];
      var b = briefOf(job);
      if (b) {
        (b.logo && b.logo.files || []).forEach(function (f) { if (f && f.url) list.push({ folder: 'logos', url: f.url, name: f.filename || nameFromUrl(f.url) }); });
        (b.reference_images || []).forEach(function (f) { if (f && f.url) list.push({ folder: 'references', url: f.url, name: f.filename || nameFromUrl(f.url), img: true }); });
        (b.gallery_references || []).forEach(function (g) { var u = g && (g.image || g.url); if (u) list.push({ folder: 'gallery', url: u, name: (g.title ? slug(g.title) + '-' : '') + nameFromUrl(u), img: true }); });
      }
      (rounds || []).forEach(function (r) {
        (r.files || []).forEach(function (f) { if (f && f.url) list.push({ folder: 'proofs/round-' + r.round_number, url: f.url, name: f.filename || nameFromUrl(f.url), img: true }); });
      });
      var cms = (job._chat || []).slice();
      (rounds || []).forEach(function (r) { cms = cms.concat(r.comments || []); });
      cms.forEach(function (cm) {
        parseBody(cm.body).files.forEach(function (f) { list.push({ folder: 'chat', url: f.url, name: f.filename || nameFromUrl(f.url) }); });
      });
      return list;
    }

    function briefText(job, rounds) {
      var L = [];
      L.push('JOB: ' + (job.title || '')); L.push('ID: ' + job.id); L.push('STATUS: ' + (STATUS_LABEL[job.status] || job.status));
      if (job.contact_name || job.customer_email) L.push('CLIENT: ' + [job.contact_name, job.customer_email].filter(Boolean).join(' / '));
      if (job.summary) L.push('', 'SUMMARY:', job.summary);
      var b = briefOf(job);
      if (b) {
        L.push('', 'BRIEF:');
        if (b.art_option && b.art_option.name) L.push('Layout: ' + b.art_option.name + (b.art_option.price ? ' ($' + b.art_option.price + ')' : ''));
        if (b.extra_vehicles && b.extra_vehicles.count) L.push('Extra vehicles: ' + b.extra_vehicles.count);
        if (b.business) { if (b.business.freight_type) L.push('Freight: ' + b.business.freight_type); if (b.business.home_base) L.push('Home base: ' + b.business.home_base); if (b.business.routes) L.push('Routes: ' + b.business.routes); }
        if (b.subject_description) L.push('Details: ' + b.subject_description);
        if (b.logo && b.logo.choice) L.push('Logo: ' + human(b.logo.choice));
        if (b.copyright_choice) L.push('Copyright: ' + human(b.copyright_choice));
        if (b.notes) L.push('Notes: ' + b.notes);
        if (b.timeline && b.timeline.deadline) L.push('Deadline: ' + fmtDeadline(b.timeline.deadline));
      }
      (rounds || []).forEach(function (r) {
        L.push('', 'ROUND ' + r.round_number + (r.approval ? ' - APPROVED by ' + r.approval.signed_name + ' (' + fmtDate(r.approval.approved_at) + ')' : ''));
        if (r.note) L.push('Note: ' + r.note);
        (r.comments || []).forEach(function (c) { L.push('[' + fmtDate(c.created_at) + '] ' + (c.author === 'lid' ? 'Lucky Inger' : (c.author_name || 'Client')) + ': ' + c.body); });
      });
      return L.join('\r\n');
    }

    function fetchBlob(u) {
      var abs = absUrl(u);
      return fetch(abs, { mode: 'cors' }).then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.blob();
      }).catch(function () {
        return fetch(workerUrl + '/admin/proxy?u=' + encodeURIComponent(abs), { headers: { 'x-staff-token': staffToken } }).then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.blob();
        });
      });
    }

    /* Where downloads go. Chrome/Edge support the File System Access API, which
       lets staff pick a save location or a default folder. Other browsers fall
       back to a normal download into the Downloads folder. */
    var FS_OK = typeof window.showDirectoryPicker === 'function' && typeof window.showSaveFilePicker === 'function';
    var defaultDir = null;

    function kvStore(mode, fn) {
      return new Promise(function (resolve, reject) {
        if (!window.indexedDB) { reject(new Error('No storage')); return; }
        var req = indexedDB.open('lid-proof-studio', 1);
        req.onupgradeneeded = function () { req.result.createObjectStore('kv'); };
        req.onerror = function () { reject(req.error); };
        req.onsuccess = function () {
          try {
            var tx = req.result.transaction('kv', mode);
            var r = fn(tx.objectStore('kv'));
            tx.oncomplete = function () { resolve(r && 'result' in r ? r.result : undefined); };
            tx.onerror = function () { reject(tx.error); };
          } catch (e) { reject(e); }
        };
      });
    }
    function loadDefaultDir() {
      if (!FS_OK) return;
      kvStore('readonly', function (s) { return s.get('dlDir'); }).then(function (h) { defaultDir = h || null; }).catch(function () {});
    }
    function saveDefaultDir(h) {
      defaultDir = h || null;
      return kvStore('readwrite', function (s) { return h ? s.put(h, 'dlDir') : s.delete('dlDir'); }).catch(function () {});
    }
    function ensurePermission(h) {
      var o = { mode: 'readwrite' };
      return h.queryPermission(o).then(function (st) {
        if (st === 'granted') return true;
        return h.requestPermission(o).then(function (st2) { return st2 === 'granted'; });
      });
    }
    function pickZipTarget(root) {
      return window.showSaveFilePicker({
        id: 'lid-proof-zip', startIn: 'downloads', suggestedName: root + '.zip',
        types: [{ description: 'Zip archive', accept: { 'application/zip': ['.zip'] } }]
      }).then(function (h) { return { type: 'zip', handle: h }; });
    }
    function pickFolderTarget() {
      return window.showDirectoryPicker({ id: 'lid-proof-folder', mode: 'readwrite', startIn: 'downloads' })
        .then(function (h) { return { type: 'dir', handle: h }; });
    }
    function writeFileTo(dir, path, blob) {
      var parts = path.split('/'), name = parts.pop();
      var p = Promise.resolve(dir);
      parts.forEach(function (part) { p = p.then(function (d) { return d.getDirectoryHandle(part, { create: true }); }); });
      return p.then(function (d) { return d.getFileHandle(name, { create: true }); })
        .then(function (fh) { return fh.createWritable(); })
        .then(function (w) { return w.write(blob).then(function () { return w.close(); }); });
    }

    // mode: 'auto' (default folder, else ask where to save the zip), 'zip-pick', 'folder-pick'
    function downloadAll(job, rounds, btn, toast, mode) {
      mode = mode || 'auto';
      var files = collectFiles(job, rounds);
      var root = slug(jobName(job) || job.id);
      var label = btn.innerHTML;
      toastMsg(toast, '');

      // Pickers and permission prompts must open straight from the click, before any downloading.
      var targetP;
      if (!FS_OK) targetP = Promise.resolve({ type: 'browser' });
      else if (mode === 'zip-pick') targetP = pickZipTarget(root);
      else if (mode === 'folder-pick') targetP = pickFolderTarget();
      else if (defaultDir) targetP = ensurePermission(defaultDir).then(function (ok) {
        if (!ok) throw new Error('No permission to save into ' + defaultDir.name);
        return { type: 'dir', handle: defaultDir };
      });
      else targetP = pickZipTarget(root);

      return targetP.then(function (target) {
        btn.disabled = true; btn.textContent = 'Preparing';
        var entries = [{ path: 'brief.txt', blob: new Blob([briefText(job, rounds)], { type: 'text/plain' }) }];
        var used = {}, failed = [], done = 0;
        function uniqueName(dir, name) {
          name = slug(name);
          var key = dir + '/' + name.toLowerCase(), n = 1, base = name, ext = '';
          var dot = name.lastIndexOf('.'); if (dot > 0) { base = name.slice(0, dot); ext = name.slice(dot); }
          while (used[key]) { name = base + '-' + (++n) + ext; key = dir + '/' + name.toLowerCase(); }
          used[key] = true; return name;
        }
        var queue = files.slice(), running = 0;
        return new Promise(function (resolve) {
          if (!queue.length) { resolve(); return; }
          function next() {
            if (!queue.length) { if (!running) resolve(); return; }
            var f = queue.shift(); running++;
            fetchBlob(f.url).then(function (blob) {
              entries.push({ path: f.folder + '/' + uniqueName(f.folder, f.name), blob: blob });
            }).catch(function () { failed.push(f.folder + ': ' + (f.name || f.url) + '  ' + f.url); })
              .then(function () { running--; done++; btn.textContent = 'Downloading ' + done + '/' + files.length; next(); });
          }
          for (var i = 0; i < 4; i++) next();
        }).then(function () {
          if (failed.length) entries.push({ path: 'MISSING-FILES.txt', blob: new Blob(['These files could not be downloaded:\r\n\r\n' + failed.join('\r\n')], { type: 'text/plain' }) });
          var ok = files.length - failed.length;
          var tail = failed.length ? (', ' + failed.length + ' failed (see MISSING-FILES.txt)') : '';

          if (target.type === 'dir') {
            btn.textContent = 'Saving';
            return target.handle.getDirectoryHandle(root, { create: true }).then(function (jobDir) {
              return entries.reduce(function (p, e) { return p.then(function () { return writeFileTo(jobDir, e.path, e.blob); }); }, Promise.resolve());
            }).then(function () {
              toastMsg(toast, 'Saved ' + ok + ' file' + (ok !== 1 ? 's' : '') + ' to ' + target.handle.name + '/' + root + tail, failed.length ? 'err' : 'ok', true);
            });
          }

          btn.textContent = 'Zipping';
          return loadJSZip().then(function (JSZip) {
            var zip = new JSZip(); var folder = zip.folder(root);
            entries.forEach(function (e) { folder.file(e.path, e.blob); });
            return zip.generateAsync({ type: 'blob' });
          }).then(function (blob) {
            if (target.type === 'zip') {
              return target.handle.createWritable().then(function (w) { return w.write(blob).then(function () { return w.close(); }); }).then(function () {
                toastMsg(toast, 'Saved ' + target.handle.name + tail, failed.length ? 'err' : 'ok', true);
              });
            }
            var a = document.createElement('a');
            a.href = URL.createObjectURL(blob); a.download = root + '.zip';
            document.body.appendChild(a); a.click(); document.body.removeChild(a);
            setTimeout(function () { URL.revokeObjectURL(a.href); }, 5000);
            toastMsg(toast, 'Downloaded ' + root + '.zip' + tail, failed.length ? 'err' : 'ok', !!failed.length);
          });
        });
      }).catch(function (err) {
        if (err && err.name === 'AbortError') return; // picker cancelled
        toastMsg(toast, 'Download failed: ' + ((err && err.message) || 'unknown error'), 'err', true);
      }).then(function () { btn.disabled = false; btn.innerHTML = label; });
    }

    // Split button: [Download all][v] with save-location options
    function buildDownloadControl(job, rounds, toast) {
      var group = document.createElement('div'); group.className = 'ps-split ps-more';
      var main = document.createElement('button'); main.type = 'button'; main.className = 'ps-btn ps-btn-ghost'; main.innerHTML = icon(IC.down) + 'Download all';
      var caret = document.createElement('button'); caret.type = 'button'; caret.className = 'ps-btn ps-btn-ghost ps-split-caret'; caret.title = 'Download options'; caret.setAttribute('aria-label', 'Download options'); caret.setAttribute('aria-haspopup', 'true');
      caret.innerHTML = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M6 8l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      var menu = document.createElement('div'); menu.className = 'ps-menu ps-menu-left'; menu.hidden = true; menu.setAttribute('role', 'menu');
      group.appendChild(main); group.appendChild(caret); group.appendChild(menu);

      function updateTitle() {
        main.title = !FS_OK ? 'Saves a zip to your Downloads folder'
          : defaultDir ? ('Saves into ' + defaultDir.name + '/' + slug(jobName(job) || job.id))
          : 'Choose where to save the zip';
      }
      function buildMenu() {
        if (!FS_OK) {
          menu.innerHTML = '<div class="ps-menu-note">This browser always saves to your Downloads folder. Open the studio in Chrome or Edge to choose where files go.</div>';
          return;
        }
        menu.innerHTML =
          '<button type="button" data-dl="zip-pick" role="menuitem">' + icon(IC.down) + 'Save zip to\u2026</button>' +
          '<button type="button" data-dl="folder-pick" role="menuitem">' + icon(IC.folder) + 'Save into a folder\u2026</button>' +
          '<hr><div class="ps-menu-note">' + (defaultDir
            ? 'Default folder: <strong>' + esc(defaultDir.name) + '</strong><br>Download all saves straight into it.'
            : 'No default folder. Set one to save in one click.') + '</div>' +
          '<button type="button" data-dl="set-default" role="menuitem">' + icon(IC.folder) + (defaultDir ? 'Change default folder\u2026' : 'Set default folder\u2026') + '</button>' +
          (defaultDir ? '<button type="button" data-dl="clear-default" role="menuitem">' + icon(IC.x) + 'Stop using default folder</button>' : '');
      }
      updateTitle();
      main.addEventListener('click', function () { downloadAll(job, rounds, main, toast, 'auto'); });
      caret.addEventListener('click', function (e) {
        e.stopPropagation();
        var willOpen = menu.hidden;
        closeMenu();
        if (willOpen) { buildMenu(); menu.hidden = false; openMenu = menu; }
      });
      menu.addEventListener('click', function (e) {
        var t = e.target.closest('[data-dl]');
        if (!t) return;
        closeMenu();
        var act = t.dataset.dl;
        if (act === 'zip-pick' || act === 'folder-pick') downloadAll(job, rounds, main, toast, act);
        else if (act === 'set-default') {
          window.showDirectoryPicker({ id: 'lid-proof-default', mode: 'readwrite', startIn: 'downloads' }).then(function (h) {
            return saveDefaultDir(h).then(function () { updateTitle(); toastMsg(toast, 'Default folder set to ' + h.name, 'ok'); });
          }).catch(function (err) { if (!err || err.name !== 'AbortError') toastMsg(toast, 'Could not set folder', 'err'); });
        } else if (act === 'clear-default') {
          saveDefaultDir(null).then(function () { updateTitle(); toastMsg(toast, 'Default folder cleared', 'ok'); });
        }
      });
      return { el: group, main: main };
    }

    function toastMsg(el, text, kind, sticky) {
      if (!el) return;
      el.textContent = text || '';
      el.className = 'ps-toast' + (kind ? ' is-' + kind : '');
      clearTimeout(el._t);
      if (text && !sticky) el._t = setTimeout(function () { el.textContent = ''; }, 2500);
    }

    function fileTile(f, tag) {
      var a = document.createElement('a'); a.className = 'ps-file'; a.href = f.url; a.target = '_blank'; a.rel = 'noopener'; a.title = f.name || '';
      var media = document.createElement('div'); media.className = 'ps-file-media';
      function asExt() { media.innerHTML = '<span class="ps-file-ext">' + esc(extOf(f.name || f.url)) + '</span>'; }
      if (f.img || isImageName(f.name) || isImageName(f.url)) {
        var im = document.createElement('img'); im.src = f.url; im.alt = f.name || ''; im.loading = 'lazy';
        im.addEventListener('error', asExt);
        media.appendChild(im);
      } else asExt();
      a.appendChild(media);
      var cap = document.createElement('div'); cap.className = 'ps-file-cap';
      cap.innerHTML = (tag ? '<em>' + esc(tag) + '</em>' : '') + '<span>' + esc(f.name || 'file') + '</span>';
      a.appendChild(cap);
      return a;
    }

    /* ---- Job view -------------------------------------------------------- */

    function openJob(job, keep) {
      var seq = ++openSeq;
      selectedId = job.id; setJobParam(job.id); markSelected();
      elApp.classList.add('is-detail');
      if (!keep) elDetail.innerHTML = '<div class="ps-pane-loading"><div class="ps-spinner"></div></div>';
      if (isMobile() && !keep) window.scrollTo({ top: 0 });
      return pubFetch('/job?j=' + encodeURIComponent(job.id) + '&t=' + encodeURIComponent(job.access_token)).then(function (r) {
        if (seq !== openSeq) return;
        lastJobSig = jobSig(r.body);
        renderJob(job, (r.body && r.body.rounds) || [], (r.body && r.body.chat) || []);
      }).catch(function () {
        if (seq !== openSeq) return;
        elDetail.innerHTML = '<div class="ps-empty"><h2>Could not load this job</h2><p>Check your connection and try again.</p></div>';
      });
    }

    var openMenu = null;
    function closeMenu() { if (openMenu) { openMenu.hidden = true; openMenu = null; } }
    document.addEventListener('click', function (e) { if (openMenu && !openMenu.parentNode.contains(e.target)) closeMenu(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });

    function renderJob(job, rounds, chat) {
      job._chat = chat;
      var scrollY = window.scrollY;
      closeMenu();
      elDetail.innerHTML = '';
      var link = hubUrl
        ? (hubUrl + '?j=' + encodeURIComponent(job.id) + '&t=' + encodeURIComponent(job.access_token))
        : (workerUrl + '/hub?j=' + encodeURIComponent(job.id) + '&t=' + encodeURIComponent(job.access_token));
      var files = collectFiles(job, rounds);
      if (currentTabJob !== job.id) { currentTabJob = job.id; currentTab = (rounds.length || chat.length) ? 'chat' : 'brief'; }

      /* Header: name + status, meta, actions */
      var head = document.createElement('div'); head.className = 'ps-head';
      var meta = [];
      if (job.contact_name) meta.push('<span>' + esc(job.contact_name) + '</span>');
      if (job.customer_email) meta.push('<a href="mailto:' + esc(job.customer_email) + '">' + esc(job.customer_email) + '</a>');
      if (job.created_at) meta.push('<span>Received ' + esc(fmtDay(job.created_at)) + '</span>');
      var headRow = document.createElement('div'); headRow.className = 'ps-head-row';
      headRow.innerHTML = '<div><h2>' + esc(jobName(job)) + '</h2><div class="ps-meta">' + meta.join('') + '</div></div>';

      var stWrap = document.createElement('label'); stWrap.className = 'ps-status-select';
      var sel = document.createElement('select'); sel.setAttribute('aria-label', 'Job status');
      STATUS_OPTS.forEach(function (s) { var o = document.createElement('option'); o.value = s; o.textContent = STATUS_LABEL[s]; sel.appendChild(o); });
      stWrap.appendChild(sel); headRow.appendChild(stWrap); head.appendChild(headRow);

      var actions = document.createElement('div'); actions.className = 'ps-actions';
      var bSend = document.createElement('button'); bSend.type = 'button'; bSend.className = 'ps-btn'; bSend.innerHTML = icon(IC.send) + 'Send proof';
      var bAppr = document.createElement('button'); bAppr.type = 'button'; bAppr.className = 'ps-btn ps-btn-ghost'; bAppr.innerHTML = icon(IC.check) + 'Mark approved';
      var bCopy = document.createElement('button'); bCopy.type = 'button'; bCopy.className = 'ps-btn ps-btn-ghost'; bCopy.innerHTML = icon(IC.link) + 'Copy client link';
      var toast = document.createElement('span'); toast.className = 'ps-toast';
      var spacer = document.createElement('span'); spacer.className = 'ps-spacer';

      var more = document.createElement('div'); more.className = 'ps-more';
      var bMore = document.createElement('button'); bMore.type = 'button'; bMore.className = 'ps-icon-btn is-bordered'; bMore.title = 'More'; bMore.setAttribute('aria-label', 'More actions'); bMore.setAttribute('aria-haspopup', 'true');
      bMore.innerHTML = '<svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="5" cy="10" r="1.4" fill="currentColor"/><circle cx="10" cy="10" r="1.4" fill="currentColor"/><circle cx="15" cy="10" r="1.4" fill="currentColor"/></svg>';
      var menu = document.createElement('div'); menu.className = 'ps-menu'; menu.hidden = true; menu.setAttribute('role', 'menu');
      menu.innerHTML =
        '<a href="' + esc(link) + '" target="_blank" rel="noopener" role="menuitem">' + icon(IC.open) + 'Open client page</a>' +
        (job.customer_email ? '<button type="button" data-act="nudge" role="menuitem">' + icon(IC.send) + 'Email client about this job</button>' : '') +
        (job.customer_email ? '<a href="mailto:' + esc(job.customer_email) + '" role="menuitem">' + icon(IC.mail) + 'Write your own email</a>' : '') +
        '<button type="button" data-act="copyid" role="menuitem">' + icon(IC.copy) + 'Copy job ID</button>' +
        '<hr><button type="button" data-act="delete" class="is-danger" role="menuitem">' + icon(IC.trash) + 'Delete job</button>';
      more.appendChild(bMore); more.appendChild(menu);
      bMore.addEventListener('click', function (e) {
        e.stopPropagation();
        var willOpen = menu.hidden;
        closeMenu();
        if (willOpen) { menu.hidden = false; openMenu = menu; }
      });
      menu.addEventListener('click', function (e) {
        var t = e.target.closest('[data-act]');
        closeMenu();
        if (!t) return;
        if (t.dataset.act === 'copyid') copyText(job.id).then(function () { toastMsg(toast, 'Job ID copied', 'ok'); });
        if (t.dataset.act === 'delete') deleteJob(job);
        if (t.dataset.act === 'nudge') {
          toastMsg(toast, 'Emailing client', '', true);
          adminFetch('/admin/notify-client', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ job_id: job.id }) }).then(function (r) {
            if (r.ok && r.body && r.body.success) toastMsg(toast, 'Emailed ' + r.body.to + ' (' + r.body.sent + ')', 'ok');
            else toastMsg(toast, 'Email not sent: ' + ((r.body && r.body.error) || ('HTTP ' + r.status)), 'err', true);
          }).catch(function () { toastMsg(toast, 'Email not sent: connection error', 'err', true); });
        }
      });

      var dl = buildDownloadControl(job, rounds, toast);
      [bSend, bAppr, dl.el, bCopy, toast, spacer, more].forEach(function (el) { actions.appendChild(el); });
      head.appendChild(actions);
      elDetail.appendChild(head);

      function syncStatus() {
        sel.value = job.status;
        stWrap.className = 'ps-status-select st-' + job.status;
        // Mark approved only shows once a proof is with the client.
        bAppr.hidden = !(job.status === 'proof_sent' || job.status === 'changes_requested');
      }
      function setStatus(st) {
        var prev = job.status;
        job.status = st; syncStatus();
        return adminFetch('/admin/job-status', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ job_id: job.id, status: st }) }).then(function (r) {
          if (!r.ok || !r.body || !r.body.success) throw new Error();
          renderList(); toastMsg(toast, 'Status updated', 'ok');
        }).catch(function () { job.status = prev; syncStatus(); toastMsg(toast, 'Status not saved', 'err', true); });
      }
      syncStatus();
      sel.addEventListener('change', function () { setStatus(sel.value); });
      bAppr.addEventListener('click', function () { setStatus('approved'); });
      bCopy.addEventListener('click', function () { copyText(link).then(function () { toastMsg(toast, 'Client link copied', 'ok'); }); });

      /* Tabs */
      var tabs = document.createElement('div'); tabs.className = 'ps-tabs'; tabs.setAttribute('role', 'tablist');
      var body = document.createElement('div'); body.className = 'ps-body';
      var panes = {}, tabBtns = {};
      [['brief', 'Brief', null], ['chat', 'Chat', null], ['files', 'Files', files.length]].forEach(function (t) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'ps-tab'; b.setAttribute('role', 'tab');
        b.innerHTML = esc(t[1]) + (t[2] != null ? '<em>' + t[2] + '</em>' : '');
        b.addEventListener('click', function () { selectTab(t[0]); });
        tabBtns[t[0]] = b; tabs.appendChild(b);
      });
      elDetail.appendChild(tabs); elDetail.appendChild(body);
      function selectTab(key) {
        currentTab = key;
        Object.keys(tabBtns).forEach(function (k) { var on = k === key; tabBtns[k].classList.toggle('is-on', on); tabBtns[k].setAttribute('aria-selected', on ? 'true' : 'false'); });
        Object.keys(panes).forEach(function (k) { panes[k].hidden = k !== key; });
      }

      panes.brief = renderBrief(job, files, function () { selectTab('files'); });
      panes.chat = renderChat(job, rounds, chat);
      panes.files = renderFiles(files, function (btn) { downloadAll(job, rounds, btn, toast, 'auto'); });
      Object.keys(panes).forEach(function (k) { body.appendChild(panes[k]); });
      selectTab(currentTab);

      bSend.addEventListener('click', function () { openProofModal(job, rounds.length + 1); });

      if (!isMobile()) window.scrollTo({ top: scrollY });
    }

    /* Brief: key facts strip, then the brief as a simple document, then client files */
    function renderBrief(job, files, goFiles) {
      var pane = document.createElement('div');
      var b = briefOf(job);
      if (!b) { pane.innerHTML = '<div class="ps-none">This job has no brief details.</div>'; return pane; }

      var facts = [];
      if (b.art_option && b.art_option.name) facts.push(['Layout', b.art_option.name, b.art_option.price ? '$' + b.art_option.price : '', '']);
      if (b.extra_vehicles && b.extra_vehicles.count) facts.push(['Extra vehicles', String(b.extra_vehicles.count), '', '']);
      if (b.timeline && b.timeline.deadline) { var di = dueInfo(b.timeline.deadline); facts.push(['Deadline', fmtDeadline(b.timeline.deadline), di.text, di.cls]); }
      if (b.logo && b.logo.choice) facts.push(['Logo', human(b.logo.choice), '', '']);
      if (b.copyright_choice) facts.push(['Copyright', human(b.copyright_choice), '', '']);
      if (b.business && b.business.home_base) facts.push(['Home base', b.business.home_base, '', '']);

      if (facts.length) {
        var fs = document.createElement('div'); fs.className = 'ps-section';
        var fg = document.createElement('div'); fg.className = 'ps-facts';
        facts.forEach(function (f) {
          var t = document.createElement('div'); t.className = 'ps-fact';
          t.innerHTML = '<span class="ps-label">' + esc(f[0]) + '</span><strong>' + esc(f[1]) + '</strong>' + (f[2] ? '<small class="' + f[3] + '">' + esc(f[2]) + '</small>' : '');
          fg.appendChild(t);
        });
        fs.appendChild(fg); pane.appendChild(fs);
      }

      var rows = [];
      if (b.notes) rows.push(['Client notes', b.notes]);
      if (b.subject_description) rows.push(['Artwork details', b.subject_description]);
      if (b.business && b.business.freight_type) rows.push(['Freight', b.business.freight_type]);
      if (b.business && b.business.routes) rows.push(['Routes', b.business.routes]);
      if (job.summary && !b.notes && !b.subject_description) rows.push(['Summary', job.summary]);
      if (rows.length) {
        var ds = document.createElement('div'); ds.className = 'ps-section';
        var doc = document.createElement('div'); doc.className = 'ps-doc';
        rows.forEach(function (r) {
          var row = document.createElement('div'); row.className = 'ps-doc-row';
          row.innerHTML = '<span class="ps-label">' + esc(r[0]) + '</span><p></p>';
          row.querySelector('p').textContent = r[1];
          doc.appendChild(row);
        });
        ds.appendChild(doc); pane.appendChild(ds);
      }

      var supplied = files.filter(function (f) { return f.folder.indexOf('proofs/') !== 0; });
      if (supplied.length) {
        var ss = document.createElement('div'); ss.className = 'ps-section';
        var lbl = document.createElement('div'); lbl.className = 'ps-label';
        lbl.innerHTML = '<span>From the client (' + supplied.length + ')</span>';
        var more = document.createElement('button'); more.type = 'button'; more.textContent = 'View all files';
        more.addEventListener('click', goFiles); lbl.appendChild(more);
        var grid = document.createElement('div'); grid.className = 'ps-grid';
        supplied.forEach(function (f) { grid.appendChild(fileTile(f, f.folder === 'logos' ? 'Logo' : f.folder === 'gallery' ? 'Gallery' : '')); });
        ss.appendChild(lbl); ss.appendChild(grid); pane.appendChild(ss);
      }
      return pane;
    }

    function renderFiles(files, onZip) {
      var pane = document.createElement('div');
      if (!files.length) { pane.innerHTML = '<div class="ps-none">No files on this job yet.</div>'; return pane; }
      var bar = document.createElement('div'); bar.className = 'ps-files-bar';
      bar.innerHTML = '<span>' + files.length + ' file' + (files.length !== 1 ? 's' : '') + '</span>';
      var zb = document.createElement('button'); zb.type = 'button'; zb.className = 'ps-btn ps-btn-ghost ps-btn-sm'; zb.innerHTML = icon(IC.down) + 'Download all';
      zb.addEventListener('click', function () { onZip(zb); });
      bar.appendChild(zb); pane.appendChild(bar);
      var NAMES = { logos: 'Logo files', references: 'Reference images', gallery: 'Gallery picks', chat: 'Shared in chat' };
      var order = [], by = {};
      files.forEach(function (f) { if (!by[f.folder]) { by[f.folder] = []; order.push(f.folder); } by[f.folder].push(f); });
      order.sort(function (a, b) {
        var pa = a.indexOf('proofs/') === 0, pb = b.indexOf('proofs/') === 0;
        if (pa !== pb) return pa ? -1 : 1;
        return pa ? b.localeCompare(a, undefined, { numeric: true }) : 0;
      });
      order.forEach(function (k) {
        var s = document.createElement('div'); s.className = 'ps-section';
        var name = NAMES[k] || ('Proofs, round ' + k.split('-').pop());
        s.innerHTML = '<div class="ps-label"><span>' + esc(name) + ' (' + by[k].length + ')</span></div>';
        var g = document.createElement('div'); g.className = 'ps-grid';
        by[k].forEach(function (f) { g.appendChild(fileTile(f)); });
        s.appendChild(g); pane.appendChild(s);
      });
      return pane;
    }

    /* One chat per job: messages and proofs in a single timeline, one composer.
       Text only sends a message. Text with images sends a proof round. */
    var composerNotice = null;

    function renderChat(job, rounds, chat) {
      var pane = document.createElement('div'); pane.className = 'ps-chat';
      var events = [];
      function ts(s) { var d = toDate(s); return d ? d.getTime() : 0; }
      chat.forEach(function (c) { events.push({ t: ts(c.created_at), type: 'msg', c: c }); });
      rounds.forEach(function (r) {
        events.push({ t: ts(r.created_at), type: 'proof', r: r });
        (r.comments || []).forEach(function (c) { events.push({ t: ts(c.created_at), type: 'msg', c: c }); });
        if (r.approval) events.push({ t: ts(r.approval.approved_at), type: 'approval', r: r });
      });
      events.sort(function (a, b) { return a.t - b.t; });

      var log = document.createElement('div'); log.className = 'ps-log';
      if (!events.length) {
        log.innerHTML = '<div class="ps-log-empty"><strong>No messages yet</strong>Write to the client below, or attach images to send the first proof.</div>';
      }
      var lastDay = '';
      events.forEach(function (e) {
        var day = e.t ? new Date(e.t).toLocaleDateString('en-AU', { weekday: 'short', day: 'numeric', month: 'short' }) : '';
        if (day && day !== lastDay) {
          var sep = document.createElement('div'); sep.className = 'ps-day'; sep.innerHTML = '<span>' + esc(day) + '</span>';
          log.appendChild(sep); lastDay = day;
        }
        var time = e.t ? new Date(e.t).toLocaleTimeString('en-AU', { hour: 'numeric', minute: '2-digit' }) : '';
        if (e.type === 'msg') {
          var lid = e.c.author === 'lid';
          var el = document.createElement('div'); el.className = 'ps-cmt' + (lid ? ' is-lid' : '');
          var pb = parseBody(e.c.body);
          el.innerHTML = '<div class="ps-cmt-meta"><strong>' + esc(lid ? 'You' : (e.c.author_name || job.contact_name || 'Client')) + '</strong>' + esc(time) + '</div>' + (pb.text ? '<div class="ps-cmt-body"></div>' : '');
          if (pb.text) el.querySelector('.ps-cmt-body').textContent = pb.text;
          if (pb.files.length) el.appendChild(attachmentsEl(pb.files));
          log.appendChild(el);
        } else if (e.type === 'proof') {
          var r = e.r;
          var st = r.status === 'approved' ? 'approved' : r.status === 'changes_requested' ? 'changes_requested' : 'proof_sent';
          var stLabel = st === 'approved' ? 'Approved' : st === 'changes_requested' ? 'Changes requested' : 'Waiting on client';
          var card = document.createElement('div'); card.className = 'ps-proofcard';
          card.innerHTML = '<div class="ps-proofcard-head"><span class="ps-proofcard-title">Round ' + esc(r.round_number) + ' proof</span><span class="ps-st st-' + st + '">' + esc(stLabel) + '</span><time>' + esc(time) + '</time></div>';
          if (r.note) { var nt = document.createElement('p'); nt.className = 'ps-proofcard-note'; nt.textContent = r.note; card.appendChild(nt); }
          if (r.files && r.files.length) {
            var g = document.createElement('div'); g.className = 'ps-proofcard-files';
            r.files.forEach(function (f) {
              var a = document.createElement('a'); a.href = f.url; a.target = '_blank'; a.rel = 'noopener'; a.title = f.filename || '';
              var im = document.createElement('img'); im.src = f.url; im.alt = f.filename || ''; im.loading = 'lazy';
              a.appendChild(im); g.appendChild(a);
            });
            card.appendChild(g);
          }
          log.appendChild(card);
        } else if (e.type === 'approval') {
          var ap = document.createElement('div'); ap.className = 'ps-sys is-ok';
          ap.innerHTML = icon(IC.check) + '<span><strong>' + esc(e.r.approval.signed_name) + '</strong> approved round ' + esc(e.r.round_number) + ' &middot; ' + esc(time) + '</span>';
          log.appendChild(ap);
        }
      });
      pane.appendChild(log);
      var composer = buildComposer(job);
      pane.appendChild(composer);
      pane._composer = composer;
      return pane;
    }

    /* Attachments live in the message body as [[file:URL|name]] lines. */
    function parseBody(body) {
      var files = [];
      var text = String(body || '').replace(/\[\[file:([^|\]]+)\|?([^\]]*)\]\]/g, function (_, url, name) { files.push({ url: url, filename: name || 'file' }); return ''; }).trim();
      return { text: text, files: files };
    }
    function attachmentsEl(files) {
      var wrap = document.createElement('div'); wrap.className = 'ps-att';
      files.forEach(function (f) {
        var a = document.createElement('a'); a.href = f.url; a.target = '_blank'; a.rel = 'noopener'; a.title = f.filename;
        if (isImageName(f.filename) || isImageName(f.url)) {
          a.className = 'ps-att-img';
          var im = document.createElement('img'); im.src = f.url; im.alt = f.filename; im.loading = 'lazy'; a.appendChild(im);
        } else {
          a.className = 'ps-att-file';
          a.innerHTML = icon(IC.clip) + '<span>' + esc(f.filename) + '</span>';
        }
        wrap.appendChild(a);
      });
      return wrap;
    }
    function uploadFile(f) {
      var fd = new FormData(); fd.append('file', f, f.name);
      return fetch(workerUrl + '/upload', { method: 'POST', body: fd }).then(function (res) { return res.json(); }).then(function (b) {
        if (!b || !b.success || !b.url) throw new Error((b && b.error) || 'Upload failed');
        return { url: b.url, filename: f.name };
      });
    }
    function previewGrid(files, onRemove) {
      var g = document.createElement('div'); g.className = 'ps-previews';
      files.forEach(function (f, i) {
        var cell = document.createElement('div'); cell.className = 'ps-prev';
        if (f.type && f.type.indexOf('image/') === 0) {
          var img = document.createElement('img'); img.src = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='; img.alt = ''; cell.appendChild(img);
          var reader = new FileReader(); reader.onload = function (e) { img.src = e.target.result; }; reader.readAsDataURL(f);
        } else {
          cell.innerHTML = '<span class="ps-prev-ext">' + esc(extOf(f.name)) + '</span>';
        }
        var x = document.createElement('button'); x.type = 'button'; x.textContent = '\u00d7'; x.setAttribute('aria-label', 'Remove');
        x.addEventListener('click', function () { onRemove(i); });
        cell.appendChild(x); g.appendChild(cell);
      });
      return g;
    }

    function afterSend(job, r, what) {
      var ce = r.body && r.body.client_email;
      composerNotice = !ce ? { kind: 'ok', text: what + ' sent.' }
        : ce.ok ? { kind: 'ok', text: what + ' sent. Client emailed.' }
        : { kind: 'err', text: what + ' sent, but the client email failed: ' + (ce.error || 'unknown error') };
      currentTab = 'chat';
      return openJob(job, true).then(function () {
        var c = elDetail.querySelector('.ps-composer'); if (c) c.scrollIntoView({ block: 'end' });
      });
    }

    // Chat box: messages and file attachments only. Proofs go through openProofModal.
    function buildComposer(job) {
      var box = document.createElement('div'); box.className = 'ps-composer';
      var prevHost = document.createElement('div');
      var ta = document.createElement('textarea'); ta.className = 'ps-composer-input'; ta.rows = 1;
      ta.placeholder = 'Message ' + (String(job.contact_name || '').split(' ')[0] || 'the client') + '\u2026';
      var row = document.createElement('div'); row.className = 'ps-composer-row';
      var attach = document.createElement('button'); attach.type = 'button'; attach.className = 'ps-icon-btn'; attach.title = 'Attach a file'; attach.setAttribute('aria-label', 'Attach a file');
      attach.innerHTML = icon(IC.clip);
      var input = document.createElement('input'); input.type = 'file'; input.multiple = true; input.hidden = true;
      var hint = document.createElement('span'); hint.className = 'ps-composer-hint';
      var send = document.createElement('button'); send.type = 'button'; send.className = 'ps-btn ps-btn-ghost'; send.innerHTML = icon(IC.send) + 'Send';
      row.appendChild(attach); row.appendChild(input); row.appendChild(hint); row.appendChild(send);
      box.appendChild(prevHost); box.appendChild(ta); box.appendChild(row);

      var files = [];
      var defaultHint = 'Enter to send, Shift+Enter for a new line.';
      function refresh() {
        prevHost.innerHTML = '';
        if (files.length) prevHost.appendChild(previewGrid(files, function (i) { files.splice(i, 1); refresh(); }));
        send.disabled = !files.length && !ta.value.trim();
      }
      function grow() { ta.style.height = 'auto'; ta.style.height = Math.min(ta.scrollHeight, 240) + 'px'; }
      function add(list) { for (var i = 0; i < list.length && files.length < 10; i++) files.push(list[i]); refresh(); }
      attach.addEventListener('click', function () { input.click(); });
      input.addEventListener('change', function () { if (this.files) add(this.files); this.value = ''; });
      ta.addEventListener('input', function () { grow(); refresh(); });
      ta.addEventListener('keydown', function (e) { if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) { e.preventDefault(); if (!send.disabled) send.click(); } });
      box.addEventListener('dragover', function (e) { e.preventDefault(); box.classList.add('is-over'); });
      box.addEventListener('dragleave', function (e) { if (!box.contains(e.relatedTarget)) box.classList.remove('is-over'); });
      box.addEventListener('drop', function (e) { e.preventDefault(); box.classList.remove('is-over'); if (e.dataTransfer && e.dataTransfer.files) add(e.dataTransfer.files); });
      box.addEventListener('paste', function (e) { var it = e.clipboardData && e.clipboardData.files; if (it && it.length) add(it); });

      function fail(msg) { var pd = elDetail.querySelector('.ps-cmt.is-pending'); if (pd) pd.remove(); send.disabled = false; send.innerHTML = icon(IC.send) + 'Send'; hint.textContent = msg; hint.className = 'ps-composer-hint is-err'; }
      send.addEventListener('click', function () {
        var text = ta.value.trim();
        if (!files.length && !text) return;
        send.disabled = true; send.textContent = files.length ? 'Uploading' : 'Sending';
        hint.className = 'ps-composer-hint'; hint.textContent = defaultHint;
        var log = elDetail.querySelector('.ps-log');
        var pending = document.createElement('div'); pending.className = 'ps-cmt is-lid is-pending';
        pending.innerHTML = '<div class="ps-cmt-meta"><strong>You</strong>Sending\u2026</div>' + (text ? '<div class="ps-cmt-body"></div>' : '') + (files.length ? '<div class="ps-cmt-meta">' + files.length + ' attachment' + (files.length !== 1 ? 's' : '') + '</div>' : '');
        if (text) pending.querySelector('.ps-cmt-body').textContent = text;
        if (log) { var em = log.querySelector('.ps-log-empty'); if (em) em.remove(); log.appendChild(pending); box.scrollIntoView({ block: 'end' }); }
        Promise.all(files.map(uploadFile)).then(function (atts) {
          send.textContent = 'Sending';
          return adminFetch('/admin/message', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ job_id: job.id, body: text, attachments: atts }) });
        }).then(function (r) {
          if (!r.ok || !r.body || !r.body.success) { fail((r.body && r.body.error) || 'Message not sent.'); return; }
          ta.value = ''; files.length = 0;
          afterSend(job, r, 'Message');
        }).catch(function (err) { fail('Not sent: ' + ((err && err.message) || 'connection error')); });
      });

      hint.textContent = defaultHint;
      refresh();
      if (composerNotice) {
        hint.textContent = composerNotice.text; hint.className = 'ps-composer-hint is-' + composerNotice.kind;
        composerNotice = null;
        setTimeout(function () { if (/is-ok/.test(hint.className)) { hint.className = 'ps-composer-hint'; hint.textContent = defaultHint; } }, 4000);
      }
      return box;
    }

    // Sending a proof is a separate, deliberate step with its own confirm.
    function openProofModal(job, nextRound) {
      var old = document.getElementById('ps-modal'); if (old) old.remove();
      var ov = document.createElement('div'); ov.className = 'ps-modal'; ov.id = 'ps-modal';
      ov.setAttribute('role', 'dialog'); ov.setAttribute('aria-modal', 'true'); ov.setAttribute('aria-label', 'Send proof');
      var card = document.createElement('div'); card.className = 'ps-modal-card';
      card.innerHTML =
        '<div class="ps-modal-head"><div><span class="ps-label">' + esc(jobName(job)) + '</span><h3>Send round ' + nextRound + ' proof</h3></div></div>' +
        '<p class="ps-modal-sub">The client gets an email with these images and a link to view and approve them. Only send artwork that\u2019s ready for their review.</p>';
      var close = document.createElement('button'); close.type = 'button'; close.className = 'ps-icon-btn'; close.setAttribute('aria-label', 'Close'); close.innerHTML = icon(IC.x);
      card.firstChild.appendChild(close);

      var drop = document.createElement('div'); drop.className = 'ps-drop';
      drop.innerHTML = icon(IC.upload) + '<span><strong>Add proof images</strong> &middot; drag here or click to browse</span>';
      var input = document.createElement('input'); input.type = 'file'; input.accept = 'image/*'; input.multiple = true;
      drop.appendChild(input);
      var prevHost = document.createElement('div');
      var note = document.createElement('textarea'); note.className = 'ps-note'; note.rows = 3; note.placeholder = 'Note for the client (optional), e.g. First concept, let us know what you think';
      var foot = document.createElement('div'); foot.className = 'ps-modal-foot';
      var msgEl = document.createElement('span'); msgEl.className = 'ps-msg';
      var cancel = document.createElement('button'); cancel.type = 'button'; cancel.className = 'ps-btn ps-btn-ghost'; cancel.textContent = 'Cancel';
      var send = document.createElement('button'); send.type = 'button'; send.className = 'ps-btn';
      foot.appendChild(msgEl); foot.appendChild(cancel); foot.appendChild(send);
      card.appendChild(drop); card.appendChild(prevHost); card.appendChild(note); card.appendChild(foot);
      ov.appendChild(card); wrap.appendChild(ov);
      document.documentElement.classList.add('ps-noscroll');

      var files = [];
      function refresh() {
        prevHost.innerHTML = '';
        if (files.length) prevHost.appendChild(previewGrid(files, function (i) { files.splice(i, 1); refresh(); }));
        send.disabled = !files.length;
        send.innerHTML = icon(IC.send) + (files.length ? 'Send ' + files.length + ' image' + (files.length !== 1 ? 's' : '') + ' as round ' + nextRound : 'Send round ' + nextRound + ' proof');
      }
      function add(list) { for (var i = 0; i < list.length; i++) { if (list[i].type.indexOf('image/') === 0) files.push(list[i]); } refresh(); }
      function shut() { ov.remove(); document.documentElement.classList.remove('ps-noscroll'); document.removeEventListener('keydown', onKey); }
      function onKey(e) { if (e.key === 'Escape' && !send.dataset.busy) shut(); }
      document.addEventListener('keydown', onKey);
      close.addEventListener('click', shut); cancel.addEventListener('click', shut);
      ov.addEventListener('click', function (e) { if (e.target === ov && !send.dataset.busy) shut(); });
      input.addEventListener('change', function () { if (this.files) add(this.files); this.value = ''; });
      drop.addEventListener('dragover', function (e) { e.preventDefault(); drop.classList.add('is-over'); });
      drop.addEventListener('dragleave', function (e) { if (e.target === drop) drop.classList.remove('is-over'); });
      drop.addEventListener('drop', function (e) { e.preventDefault(); drop.classList.remove('is-over'); if (e.dataTransfer && e.dataTransfer.files) add(e.dataTransfer.files); });

      send.addEventListener('click', function () {
        if (!files.length) return;
        var fd = new FormData(); fd.set('job_id', job.id); if (note.value.trim()) fd.set('note', note.value.trim());
        files.forEach(function (f) { fd.append('files', f, f.name); });
        send.disabled = true; send.dataset.busy = '1'; send.textContent = 'Sending'; cancel.disabled = true;
        adminFetch('/admin/round', { method: 'POST', body: fd }).then(function (r) {
          if (!r.ok || !r.body || !r.body.success) throw new Error((r.body && r.body.error) || 'Upload failed');
          shut();
          job.status = 'proof_sent'; renderList();
          afterSend(job, r, 'Round ' + nextRound + ' proof');
        }).catch(function (err) {
          delete send.dataset.busy; cancel.disabled = false; refresh();
          msgEl.className = 'ps-msg is-err'; msgEl.textContent = (err && err.message) || 'Connection error. Nothing was sent.';
        });
      });
      refresh();
      setTimeout(function () { input.click(); }, 50);
    }

    /* ---- Boot ------------------------------------------------------------ */

    function boot() {
      if (!workerUrl) { showAuthError('Setup incomplete', 'Set the Proof Worker URL in this section\u2019s settings.'); return; }
      if (!pageKey) { showAuthError('Setup incomplete', 'Set the Staff page key in this section\u2019s settings (must match STAFF_PAGE_KEY on the Worker).'); return; }
      if (!customerEmail) { showAuthError('Not signed in', 'Log in to your Shopify customer account first.'); return; }
      showAuthState('Signing in', 'Verifying your access.', false);
      loadDefaultDir();
      loginToWorker().then(function () {
        loadJobs().then(syncReplies);
      }).catch(function (err) {
        var m = (err && err.message) || 'Unknown error';
        if (m === 'Not staff') showAuthError('Not authorised', 'You\u2019re signed in, but ' + customerEmail + ' isn\u2019t on the staff allowlist. Add this email to the STAFF_EMAILS env var on the Worker.');
        else if (m === 'Bad page key') showAuthError('Setup mismatch', 'The Staff page key in this section doesn\u2019t match STAFF_PAGE_KEY on the Worker.');
        else if (m === 'Bad referer') showAuthError('Blocked', 'Request blocked by the Worker (bad referer). Make sure the page loads over the same domain configured in the Worker\u2019s allowed origins.');
        else showAuthError('Sign-in failed', m);
      });
    }

    boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["artwork-request"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var wrap = document.querySelector('.ar-wrap');
    if (!wrap) return;
    var workerUrl = wrap.getAttribute('data-worker-url') || '';
    var proofWorkerUrl = (wrap.getAttribute('data-proof-worker-url') || '').replace(/\/+$/, '');
    var contactEmail = wrap.getAttribute('data-contact-email') || '';
    var pendingUploads = 0;
    var submitWhenUploadsDone = false;
    function uploadsChanged() {
      if (pendingUploads < 0) pendingUploads = 0;
      if (pendingUploads === 0 && submitWhenUploadsDone) {
        submitWhenUploadsDone = false;
        startSubmit();
      }
    }
    var maxTotalVehicles = parseInt(wrap.getAttribute('data-max-total-vehicles'), 10);
    if (!isFinite(maxTotalVehicles) || maxTotalVehicles < 0) maxTotalVehicles = 3;

    if (wrap.getAttribute('data-customer-loggedin') === 'true') {
      var custEmail = wrap.getAttribute('data-customer-email') || '';
      var first = wrap.getAttribute('data-customer-first') || '';
      var last = wrap.getAttribute('data-customer-last') || '';
      var company = wrap.getAttribute('data-customer-company') || '';
      var custPhone = wrap.getAttribute('data-customer-phone') || '';
      function fillIfEmpty(sel, v) { var el = wrap.querySelector(sel); if (el && !el.value && v) el.value = v; }
      fillIfEmpty('input[name="email"]', custEmail);
      fillIfEmpty('input[name="contact_name"]', (first + ' ' + last).trim());
      fillIfEmpty('input[name="business_name"]', company);
      fillIfEmpty('input[name="phone"]', custPhone);
    }

    var fees = {
      logo_use_as_supplied: 0,
      logo_redraw: parseFloat(wrap.getAttribute('data-fee-logo-redraw')) || 0,
      logo_new: parseFloat(wrap.getAttribute('data-fee-logo-new')) || 0,
      extra_vehicle: parseFloat(wrap.getAttribute('data-fee-extra-vehicle')) || 0
    };

    var merchPct = parseFloat(wrap.getAttribute('data-merch-discount'));
    if (!isFinite(merchPct) || merchPct < 0 || merchPct > 100) merchPct = 0;

    function isMerchPartner() {
      var c = wrap.querySelector('input[name="merch_choice"]:checked');
      return !!c && c.value === 'merch_partner';
    }
    function merchSaving(subtotal) { return Math.round(subtotal * merchPct / 100); }
    function merchDiscount(subtotal) { return isMerchPartner() ? merchSaving(subtotal) : 0; }
    function merchTermsText() {
      return Array.prototype.map.call(wrap.querySelectorAll('#ar-merch-terms li'), function (li) { return li.textContent.trim(); }).join(' ');
    }

    function fmtFee(n) {
      if (!isFinite(n) || n <= 0) return '$0';
      return '$' + n.toLocaleString('en-AU', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    }

    Array.prototype.forEach.call(wrap.querySelectorAll('[data-fee-slot]'), function (el) {
      var key = el.getAttribute('data-fee-slot');
      if (fees[key] !== undefined) el.textContent = fmtFee(fees[key]);
    });
    var evSlot = wrap.querySelector('[data-fee-slot="extra_vehicle"]');
    if (evSlot) evSlot.textContent = '+' + fmtFee(fees.extra_vehicle) + ' each';

    // Merch partner terms popup
    var merchDialog = wrap.querySelector('#ar-merch-dialog');
    if (merchDialog) {
      Array.prototype.forEach.call(wrap.querySelectorAll('[data-merch-terms-open]'), function (btn) {
        btn.addEventListener('click', function () {
          if (typeof merchDialog.showModal === 'function') merchDialog.showModal();
          else merchDialog.setAttribute('open', '');
        });
      });
      Array.prototype.forEach.call(merchDialog.querySelectorAll('[data-merch-terms-close]'), function (btn) {
        btn.addEventListener('click', function () {
          if (typeof merchDialog.close === 'function') merchDialog.close();
          else merchDialog.removeAttribute('open');
        });
      });
      merchDialog.addEventListener('click', function (e) {
        if (e.target === merchDialog && typeof merchDialog.close === 'function') merchDialog.close();
      });
    }

    // Format layout prices with thousands separators
    Array.prototype.forEach.call(wrap.querySelectorAll('.ar-art-tile'), function (tile) {
      var price = parseFloat(tile.getAttribute('data-price')) || 0;
      var priceEl = tile.querySelector('.ar-art-price');
      if (priceEl && price > 0) priceEl.textContent = fmtFee(price);
    });

    // Merch partner price hint under each layout price
    if (merchPct > 0 && wrap.querySelector('input[name="merch_choice"]')) {
      Array.prototype.forEach.call(wrap.querySelectorAll('.ar-art-tile'), function (tile) {
        var price = parseFloat(tile.getAttribute('data-price')) || 0;
        var body = tile.querySelector('.ar-art-body');
        if (!body || price <= 0) return;
        var hint = document.createElement('div');
        hint.className = 'ar-art-price-mp';
        var strong = document.createElement('strong');
        strong.textContent = fmtFee(price - merchSaving(price));
        hint.appendChild(strong);
        hint.appendChild(document.createTextNode(' as a merch partner'));
        body.appendChild(hint);
      });
    }

    var logoNewBlock = wrap.querySelector('#ar-logo-new-direction');
    Array.prototype.forEach.call(wrap.querySelectorAll('input[name="logo_choice"]'), function (r) {
      r.addEventListener('change', function () {
        var checked = wrap.querySelector('input[name="logo_choice"]:checked');
        if (logoNewBlock && checked) logoNewBlock.hidden = checked.value !== 'new';
      });
    });

    // Extra-vehicle stepper: dynamic cap based on selected layout's baked-in count
    var extraInput = document.getElementById('ar-extra-vehicles');
    var extraCountEl = document.getElementById('ar-extra-vehicles-count');
    var addonDesc = document.getElementById('ar-addon-vehicle-desc');
    var stepMinusBtn = wrap.querySelector('.ar-stepper .ar-step-btn[data-step="-1"]');
    var stepPlusBtn = wrap.querySelector('.ar-stepper .ar-step-btn[data-step="1"]');

    function getBakedVehicles() {
      var checked = wrap.querySelector('input[name="art_option"]:checked');
      if (!checked) return null;
      var tile = checked.closest('.ar-art-tile');
      if (!tile) return null;
      var b = parseInt(tile.getAttribute('data-baked-vehicles'), 10);
      return isFinite(b) && b >= 0 ? b : 0;
    }

    function getMaxExtras() {
      var baked = getBakedVehicles();
      if (baked === null) return maxTotalVehicles; // no layout picked yet: allow full range, clamp on select
      var m = maxTotalVehicles - baked;
      return m < 0 ? 0 : m;
    }

    function updateAddonDesc() {
      if (!addonDesc) return;
      var baked = getBakedVehicles();
      if (baked === null) {
        addonDesc.textContent = 'Choose a layout first. Up to ' + maxTotalVehicles + ' vehicles per artwork.';
        return;
      }
      var maxE = getMaxExtras();
      if (maxE === 0) {
        addonDesc.textContent = 'Your layout already includes the maximum of ' + maxTotalVehicles + ' vehicles.';
      } else {
        addonDesc.textContent = 'Add another truck, trailer or machine to your layout. Up to ' + maxE + ' more (' + maxTotalVehicles + ' max).';
      }
    }

    function updateStepperState() {
      var cur = parseInt(extraInput.value, 10) || 0;
      var maxE = getMaxExtras();
      if (stepMinusBtn) stepMinusBtn.disabled = cur <= 0;
      if (stepPlusBtn) stepPlusBtn.disabled = cur >= maxE;
    }

    function clampExtrasToCurrentMax() {
      var cur = parseInt(extraInput.value, 10) || 0;
      var maxE = getMaxExtras();
      if (cur > maxE) {
        extraInput.value = maxE;
        if (extraCountEl) extraCountEl.textContent = maxE;
      }
    }

    Array.prototype.forEach.call(wrap.querySelectorAll('.ar-stepper .ar-step-btn'), function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var delta = parseInt(btn.getAttribute('data-step'), 10) || 0;
        var cur = parseInt(extraInput.value, 10) || 0;
        var maxE = getMaxExtras();
        cur = Math.max(0, Math.min(maxE, cur + delta));
        extraInput.value = cur;
        if (extraCountEl) extraCountEl.textContent = cur;
        updateStepperState();
        recalc();
      });
    });

    // Layout selection: clamp extras + update cap UI + recalc
    Array.prototype.forEach.call(wrap.querySelectorAll('input[name="art_option"]'), function (r) {
      r.addEventListener('change', function () {
        clampExtrasToCurrentMax();
        updateAddonDesc();
        updateStepperState();
        recalc();
      });
    });

    updateAddonDesc();
    updateStepperState();

    // Deadline can't be in the past
    var deadlineInput = wrap.querySelector('input[name="deadline"]');
    if (deadlineInput) {
      var now = new Date();
      deadlineInput.min = now.getFullYear() + '-' + ('0' + (now.getMonth() + 1)).slice(-2) + '-' + ('0' + now.getDate()).slice(-2);
    }

    // Artwork example carousel: small prev/next arrows (and swipe) directly on each tile's thumbnail
    (function () {
      Array.prototype.forEach.call(wrap.querySelectorAll('.ar-art-tile'), function (tile) {
        var dataEl = tile.querySelector('.ar-art-gallery-data');
        var thumb = tile.querySelector('.ar-art-thumb');
        var imageWrap = tile.querySelector('.ar-art-image');
        var prevBtn = tile.querySelector('.ar-art-nav-prev');
        var nextBtn = tile.querySelector('.ar-art-nav-next');
        if (!dataEl || !thumb) return;

        var imgs = Array.prototype.map.call(dataEl.querySelectorAll('img'), function (img) {
          return { src: img.getAttribute('src'), alt: img.getAttribute('data-caption') || img.getAttribute('alt') || '' };
        });
        if (imgs.length < 2) return; // nothing extra to browse

        var idx = 0;
        function show(i) {
          idx = (i + imgs.length) % imgs.length;
          thumb.src = imgs[idx].src;
          if (imgs[idx].alt) thumb.alt = imgs[idx].alt;
        }

        if (prevBtn) {
          prevBtn.hidden = false;
          prevBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); show(idx - 1); });
        }
        if (nextBtn) {
          nextBtn.hidden = false;
          nextBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); show(idx + 1); });
        }

        if (imageWrap) {
          var touchStartX = null, isSwipe = false;
          tile.addEventListener('touchstart', function (e) {
            var r = imageWrap.getBoundingClientRect();
            var y = e.touches[0].clientY;
            if (y < r.top || y > r.bottom) { touchStartX = null; return; }
            touchStartX = e.touches[0].clientX;
            isSwipe = false;
          }, { passive: true });
          tile.addEventListener('touchmove', function (e) {
            if (touchStartX === null) return;
            if (Math.abs(e.touches[0].clientX - touchStartX) > 10) isSwipe = true;
          }, { passive: true });
          tile.addEventListener('touchend', function (e) {
            if (touchStartX === null) return;
            var dx = e.changedTouches[0].clientX - touchStartX;
            if (isSwipe && Math.abs(dx) > 30) {
              e.preventDefault(); // swiped: don't let it register as a tile-select tap
              show(dx > 0 ? idx - 1 : idx + 1);
            }
            touchStartX = null;
          });
        }
      });
    })();

    function setupUploadZone(zone) {
      var zoneName = zone.getAttribute('data-upload-zone');
      var list = document.getElementById(zone.getAttribute('data-upload-target'));
      var input = zone.querySelector('.ar-upload-input');
      var jsonInputId = zoneName === 'refs' ? 'ar-refs-json' : zoneName === 'logo' ? 'ar-logo-json' : null;
      var jsonInput = jsonInputId ? document.getElementById(jsonInputId) : null;
      var uploaded = [], queue = [], busy = false;

      function syncJson() { if (jsonInput) jsonInput.value = JSON.stringify(uploaded); }

      function makeItem(file, queued) {
        var itemId = 'up_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8);
        var item = document.createElement('div');
        item.className = 'ar-upload-item';
        item.setAttribute('data-item-id', itemId);
        item.innerHTML = '<img class="ar-upload-thumb" src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" alt="">' +
          '<div class="ar-upload-progress' + (queued ? ' ar-queued' : '') + '"><div class="ar-spinner"></div><div>' + (queued ? 'Queued' : 'Uploading') + '</div></div>';
        list.appendChild(item);
        if (file.type && file.type.indexOf('image/') === 0) {
          var reader = new FileReader();
          reader.onload = function (ev) { var img = item.querySelector('.ar-upload-thumb'); if (img) img.src = ev.target.result; };
          reader.readAsDataURL(file);
        }
        return { itemId: itemId, item: item };
      }

      function setActive(item) {
        var p = item.querySelector('.ar-upload-progress');
        if (p) { p.classList.remove('ar-queued'); var lbl = p.querySelector('div:last-child'); if (lbl) lbl.textContent = 'Uploading'; }
      }

      function showError(item, message) {
        item.classList.add('ar-error');
        var progress = item.querySelector('.ar-upload-progress');
        if (progress) progress.remove();
        var err = document.createElement('div');
        err.className = 'ar-upload-error-msg';
        err.textContent = message || 'Upload failed';
        item.appendChild(err);
        var rm = document.createElement('button');
        rm.type = 'button'; rm.className = 'ar-upload-item-remove'; rm.textContent = '×';
        item.appendChild(rm);
      }

      function showSuccess(item, filename) {
        var progress = item.querySelector('.ar-upload-progress');
        if (progress) progress.remove();
        var rm = document.createElement('button');
        rm.type = 'button'; rm.className = 'ar-upload-item-remove'; rm.textContent = '×';
        item.appendChild(rm);
        if (filename) {
          var name = document.createElement('div');
          name.className = 'ar-upload-item-name';
          name.textContent = filename;
          item.appendChild(name);
        }
      }

      function doUpload(task) {
        return new Promise(function (resolve) {
          var uploadUrl = proofWorkerUrl ? (proofWorkerUrl + '/upload') : workerUrl;
          if (!uploadUrl) { showError(task.item, 'Upload URL not configured'); pendingUploads--; recalc(); uploadsChanged(); resolve(); return; }
          setActive(task.item);
          var fd = new FormData();
          fd.append('file', task.file, task.file.name);
          fetch(uploadUrl, { method: 'POST', body: fd })
            .then(function (res) { return res.json().then(function (b) { return { ok: res.ok, body: b, status: res.status }; }); })
            .then(function (r) {
              if (!r.ok || !r.body || !r.body.success) {
                var msg = (r.body && (r.body.error || r.body.message)) || ('HTTP ' + r.status);
                showError(task.item, msg);
                return;
              }
              uploaded.push({
                itemId: task.itemId, id: r.body.fileId, url: r.body.url,
                filename: r.body.filename || task.file.name,
                size: r.body.size || task.file.size,
                mimeType: r.body.mimeType || task.file.type
              });
              syncJson();
              showSuccess(task.item, r.body.filename || task.file.name);
            })
            .catch(function (err) { showError(task.item, err && err.message ? err.message : 'Network error'); })
            .then(function () { pendingUploads--; recalc(); uploadsChanged(); resolve(); });
        });
      }

      function processQueue() {
        if (busy || queue.length === 0) return;
        busy = true;
        doUpload(queue.shift()).then(function () { busy = false; processQueue(); });
      }

      function enqueueFiles(files) {
        for (var i = 0; i < files.length; i++) {
          var file = files[i];
          var willQueue = busy || queue.length > 0;
          var h = makeItem(file, willQueue);
          pendingUploads++;
          queue.push({ file: file, item: h.item, itemId: h.itemId });
        }
        processQueue();
      }

      input.addEventListener('change', function () {
        if (this.files && this.files.length) { enqueueFiles(this.files); this.value = ''; }
      });
      zone.addEventListener('dragover', function (e) { e.preventDefault(); zone.classList.add('ar-dragover'); });
      zone.addEventListener('dragleave', function (e) { if (e.target === zone) zone.classList.remove('ar-dragover'); });
      zone.addEventListener('drop', function (e) {
        e.preventDefault(); zone.classList.remove('ar-dragover');
        if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) enqueueFiles(e.dataTransfer.files);
      });
      list.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest('.ar-upload-item-remove');
        if (!btn) return;
        var item = btn.closest('.ar-upload-item');
        if (!item) return;
        var itemId = item.getAttribute('data-item-id');
        item.remove();
        uploaded = uploaded.filter(function (u) { return u.itemId !== itemId; });
        syncJson();
        recalc();
      });
    }
    Array.prototype.forEach.call(wrap.querySelectorAll('.ar-upload'), setupUploadZone);

    var galleryGrid = wrap.querySelector('#ar-gallery-grid');
    var gallerySelectedWrap = wrap.querySelector('#ar-gallery-selected-wrap');
    var gallerySelected = wrap.querySelector('#ar-gallery-selected');
    var galleryJson = wrap.querySelector('#ar-gallery-json');
    var selectedRefs = [];

    function renderSelected() {
      if (!gallerySelected || !gallerySelectedWrap) return;
      gallerySelected.innerHTML = '';
      if (selectedRefs.length === 0) {
        gallerySelectedWrap.hidden = true;
      } else {
        gallerySelectedWrap.hidden = false;
        selectedRefs.forEach(function (r) {
          var pill = document.createElement('div');
          pill.className = 'ar-gallery-selected-item';
          var img = document.createElement('img'); img.src = r.image; img.alt = '';
          var span = document.createElement('span'); span.textContent = r.title;
          pill.appendChild(img); pill.appendChild(span);
          gallerySelected.appendChild(pill);
        });
      }
      if (galleryJson) galleryJson.value = JSON.stringify(selectedRefs);
      recalc();
    }
    if (galleryGrid) {
      galleryGrid.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest('.ar-gallery-item');
        if (!btn) return;
        var handle = btn.getAttribute('data-gallery-handle');
        var title = btn.getAttribute('data-gallery-title');
        var image = btn.getAttribute('data-gallery-image');
        var isOn = btn.getAttribute('aria-pressed') === 'true';
        if (isOn) {
          btn.setAttribute('aria-pressed', 'false');
          selectedRefs = selectedRefs.filter(function (r) { return r.handle !== handle; });
        } else {
          btn.setAttribute('aria-pressed', 'true');
          selectedRefs.push({ handle: handle, title: title, image: image });
        }
        renderSelected();
      });
    }

    var summaryLines = wrap.querySelector('#ar-summary-lines');
    var totalValueEl = wrap.querySelector('#ar-summary-total-value');
    var stickyBar = document.getElementById('ar-sticky-bar');
    var stickyValue = document.getElementById('ar-sticky-value');
    var summaryInView = false;

    // Sticky total: only once a layout is picked, hidden while the review section is on screen
    function updateSticky() {
      if (!stickyBar) return;
      var hasLayout = !!wrap.querySelector('input[name="art_option"]:checked');
      stickyBar.hidden = !hasLayout || summaryInView;
    }
    var summaryEl = wrap.querySelector('#ar-summary');
    if (summaryEl && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        summaryInView = entries[0].isIntersecting;
        updateSticky();
      }, { threshold: 0.1 }).observe(summaryEl);
    }

    var labels = {
      logo_use_as_supplied: 'Use my logo as is', logo_redraw: 'Clean up my logo', logo_new: 'Design me a new logo'
    };

    function makeLine(labelPrefix, choiceLabel, feeText) {
      var row = document.createElement('div');
      row.className = 'ar-summary-line';
      var lbl = document.createElement('span');
      lbl.className = 'ar-summary-line-label';
      lbl.innerHTML = '<strong>' + labelPrefix + '</strong>' + choiceLabel;
      var val = document.createElement('span');
      val.className = 'ar-summary-line-value';
      val.textContent = feeText;
      row.appendChild(lbl); row.appendChild(val);
      return row;
    }

    function recalc() {
      if (!summaryLines) return;
      summaryLines.innerHTML = '';
      var total = 0;

      var logoChoice = (wrap.querySelector('input[name="logo_choice"]:checked') || {}).value;
      if (logoChoice) {
        var k = 'logo_' + logoChoice;
        var fee = fees[k] || 0;
        total += fee;
        summaryLines.appendChild(makeLine('Logo', labels[k] || logoChoice, fee > 0 ? fmtFee(fee) : 'Included'));
      }

      var artChecked = wrap.querySelector('input[name="art_option"]:checked');
      if (artChecked) {
        var artTile = artChecked.closest('.ar-art-tile');
        var artPrice = parseFloat(artTile.getAttribute('data-price')) || 0;
        total += artPrice;
        summaryLines.appendChild(makeLine('Artwork', artTile.getAttribute('data-art-name'), fmtFee(artPrice)));

        var extra = parseInt((document.getElementById('ar-extra-vehicles') || {}).value, 10) || 0;
        if (extra > 0) {
          var evSubtotal = fees.extra_vehicle * extra;
          total += evSubtotal;
          summaryLines.appendChild(makeLine('Extra vehicles', extra + ' × ' + fmtFee(fees.extra_vehicle), fmtFee(evSubtotal)));
        }
      } else {
        var w = document.createElement('div');
        w.className = 'ar-summary-empty';
        w.textContent = 'Choose a layout above to see your quote.';
        summaryLines.appendChild(w);
      }

      var merchSavingEl = document.getElementById('ar-merch-saving');
      if (merchSavingEl) merchSavingEl.textContent = total > 0 ? ('Save ' + fmtFee(merchSaving(total))) : ('Save ' + merchPct + '%');
      var discount = merchDiscount(total);
      if (discount > 0) {
        var dLine = makeLine('Merch partner', merchPct + '% off everything', '-' + fmtFee(discount));
        dLine.classList.add('ar-summary-line--discount');
        summaryLines.appendChild(dLine);
        total -= discount;
      }

      var refsCount = (JSON.parse(document.getElementById('ar-refs-json').value || '[]')).length;
      var logoCount = (JSON.parse(document.getElementById('ar-logo-json').value || '[]')).length;
      var galleryCount = (JSON.parse(document.getElementById('ar-gallery-json').value || '[]')).length;

      if (refsCount || logoCount || galleryCount) {
        var meta = document.createElement('div');
        meta.className = 'ar-summary-line';
        meta.innerHTML = '<span class="ar-summary-line-label"><strong>Attached</strong>' +
          [refsCount ? refsCount + ' ref image' + (refsCount !== 1 ? 's' : '') : null,
           logoCount ? logoCount + ' logo file' + (logoCount !== 1 ? 's' : '') : null,
           galleryCount ? galleryCount + ' gallery ref' + (galleryCount !== 1 ? 's' : '') : null].filter(Boolean).join(', ') +
          '</span><span class="ar-summary-line-value"></span>';
        summaryLines.appendChild(meta);
      }

      if (totalValueEl) totalValueEl.textContent = fmtFee(total);
      if (stickyValue) stickyValue.textContent = fmtFee(total);
      updateSticky();
    }

    Array.prototype.forEach.call(wrap.querySelectorAll('input[name="logo_choice"], input[name="merch_choice"]'), function (r) {
      r.addEventListener('change', recalc);
    });
    recalc();

    var stickySubmit = document.getElementById('ar-sticky-submit');
    if (stickySubmit) {
      stickySubmit.addEventListener('click', function () {
        var s = wrap.querySelector('#ar-summary');
        if (s) s.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    var submitBtn = document.getElementById('ar-submit');
    var submitMsg = document.getElementById('ar-submit-msg');

    function val(name) { var el = wrap.querySelector('[name="' + name + '"]'); return el ? el.value.trim() : ''; }

    function showMsg(text, kind) {
      submitMsg.hidden = false;
      submitMsg.className = 'ar-submit-msg ' + (kind === 'ok' ? 'ar-ok' : 'ar-err');
      submitMsg.textContent = text;
    }

    function validate() {
      var required = [
        { name: 'business_name', label: 'your business name' },
        { name: 'contact_name', label: 'your name' },
        { name: 'email', label: 'your email' }
      ];
      for (var i = 0; i < required.length; i++) {
        if (!val(required[i].name)) return { msg: 'Please add ' + required[i].label + '.', el: wrap.querySelector('[name="' + required[i].name + '"]') };
      }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val('email'))) return { msg: 'That email address doesn\'t look quite right.', el: wrap.querySelector('[name="email"]') };
      if (!wrap.querySelector('input[name="art_option"]:checked')) return { msg: 'Please pick an artwork layout.', el: wrap.querySelector('.ar-art-grid'), group: true };
      return null;
    }

    function clearInvalid() {
      Array.prototype.forEach.call(wrap.querySelectorAll('.ar-invalid'), function (el) {
        el.classList.remove('ar-invalid');
        el.removeAttribute('aria-invalid');
      });
      Array.prototype.forEach.call(wrap.querySelectorAll('.ar-inline-error'), function (el) { el.remove(); });
    }

    function flagInvalid(problem) {
      showMsg(problem.msg, 'err');
      var el = problem.el;
      if (!el) return;
      el.classList.add('ar-invalid');
      if (!problem.group) el.setAttribute('aria-invalid', 'true');
      var note = document.createElement('div');
      note.className = 'ar-inline-error';
      note.textContent = problem.msg;
      if (problem.group) el.parentNode.insertBefore(note, el);
      else el.parentNode.appendChild(note);
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (!problem.group) {
        setTimeout(function () {
          try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
        }, 350);
      }
    }

    function onFieldFixed(e) {
      var inv = wrap.querySelector('.ar-invalid');
      if (inv && (inv === e.target || inv.contains(e.target))) clearInvalid();
    }
    wrap.addEventListener('input', onFieldFixed);
    wrap.addEventListener('change', onFieldFixed);

    function notesWithWording() {
      var wording = val('artwork_wording');
      var notes = val('notes');
      if (!wording) return notes;
      return 'Wording on artwork: ' + wording + (notes ? '\n\n' + notes : '');
    }

    function buildPayload() {
      var logoChoice = (wrap.querySelector('input[name="logo_choice"]:checked') || {}).value;
      var artChecked = wrap.querySelector('input[name="art_option"]:checked');
      var artTile = artChecked ? artChecked.closest('.ar-art-tile') : null;
      var artPrice = artTile ? (parseFloat(artTile.getAttribute('data-price')) || 0) : 0;
      var baked = getBakedVehicles() || 0;
      var maxE = getMaxExtras();
      var extra = parseInt((document.getElementById('ar-extra-vehicles') || {}).value, 10) || 0;
      if (extra > maxE) extra = maxE;
      var extraSubtotal = fees.extra_vehicle * extra;
      var logoFee = fees['logo_' + logoChoice] || 0;
      var subtotal = logoFee + artPrice + extraSubtotal;
      var merchPartner = isMerchPartner();
      var discount = merchDiscount(subtotal);
      var total = subtotal - discount;

      return {
        type: 'artwork_request',
        business: {
          name: val('business_name'), contact: val('contact_name'), email: val('email'), phone: val('phone'),
          freight_type: val('freight_type'), home_base: val('home_base'), routes: val('routes')
        },
        subject_description: val('subject_description'),
        reference_images: JSON.parse(document.getElementById('ar-refs-json').value || '[]'),
        logo: { files: JSON.parse(document.getElementById('ar-logo-json').value || '[]'), choice: logoChoice, new_direction: val('logo_new_direction') },
        art_option: { id: artTile ? artTile.getAttribute('data-art-id') : '', name: artTile ? artTile.getAttribute('data-art-name') : '', price: artPrice, baked_vehicles: baked },
        extra_vehicles: { count: extra, fee_each: fees.extra_vehicle, subtotal: extraSubtotal, max_allowed: maxE, hard_cap_total: maxTotalVehicles },
        gallery_references: JSON.parse(document.getElementById('ar-gallery-json').value || '[]'),
        timeline: { deadline: val('deadline'), deadline_notes: val('deadline_notes') },
        artwork_wording: val('artwork_wording'),
        copyright_choice: merchPartner ? 'merch_partner' : '', notes: notesWithWording(),
        merch_rights: {
          choice: merchPartner ? 'merch_partner' : 'standard',
          discount_pct: merchPartner ? merchPct : 0,
          discount: discount,
          terms_agreed: merchPartner ? merchTermsText() : ''
        },
        fees: { logo: logoFee, artwork: artPrice, extra_vehicles: extraSubtotal, copyright: 0, subtotal: subtotal, merch_partner_discount: discount, total: total }
      };
    }

    function submitToProof() {
      if (!proofWorkerUrl) return Promise.resolve(false);
      var hubUrl = (wrap.getAttribute('data-proof-hub-url') || '').replace(/\/+$/, '');
      var art = wrap.querySelector('input[name="art_option"]:checked');
      var artName = art ? art.closest('.ar-art-tile').getAttribute('data-art-name') : '';
      var maxE = getMaxExtras();
      var extra = parseInt((document.getElementById('ar-extra-vehicles') || {}).value, 10) || 0;
      if (extra > maxE) extra = maxE;
      var biz = val('business_name');
      var summaryParts = [];
      if (artName) summaryParts.push('Layout: ' + artName + (extra ? ' + ' + extra + ' extra vehicle' + (extra !== 1 ? 's' : '') : ''));
      if (isMerchPartner()) summaryParts.push('MERCH PARTNER: ' + merchPct + '% off, Lucky Inger keeps copyright (buyout = discount amount)');
      if (val('artwork_wording')) summaryParts.push('Wording: ' + val('artwork_wording'));
      if (val('subject_description')) summaryParts.push(val('subject_description'));
      else if (val('notes')) summaryParts.push(val('notes'));

      var payload = buildPayload();
      payload.name = val('contact_name');
      payload.email = val('email');
      payload.title = biz ? (biz + ' - artwork') : 'Artwork request';
      payload.summary = summaryParts.join(' | ');

      return fetch(proofWorkerUrl + '/request', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
      }).then(function (res) {
        return res.text().then(function (txt) {
          var parsed = null;
          try { parsed = JSON.parse(txt); } catch (e) {}
          return { res: res, body: parsed };
        });
      }).then(function (r) {
        var b = r.body;
        if (!r.res.ok || !b || !b.success) {
          var errMsg = (b && (b.error || b.message)) || ('HTTP ' + r.res.status + (r.res.statusText ? ' ' + r.res.statusText : ''));
          return { ok: false, error: errMsg };
        }
        var link = b.link || (hubUrl ? (hubUrl + '?j=' + encodeURIComponent(b.job_id) + '&t=' + encodeURIComponent(b.token)) : '');
        if (link) {
          var box = document.createElement('div');
          box.className = 'ar-submit-msg ar-ok';
          var title = document.createElement('strong');
          title.className = 'ar-hub-title';
          title.textContent = 'Your project page is ready';
          var text = document.createElement('span');
          text.textContent = 'Track your brief, chat with our designers and approve your proofs, all in one place. We\'ve emailed you the link too.';
          var cta = document.createElement('div');
          cta.className = 'ar-hub-cta';
          var a = document.createElement('a');
          a.className = 'ar-hub-btn';
          a.href = link;
          a.textContent = 'Open my project page';
          cta.appendChild(a);
          box.appendChild(title); box.appendChild(text); box.appendChild(cta);
          submitMsg.parentNode.insertBefore(box, submitMsg.nextSibling);
        }
        return { ok: true };
      }).catch(function (err) {
        return { ok: false, error: (err && err.message) ? err.message : 'Network error' };
      });
    }

    function failText(reason) {
      return 'Submit failed: ' + reason + '. Please try again' + (contactEmail ? ', or email us at ' + contactEmail : '') + '.';
    }

    submitBtn.addEventListener('click', function () {
      clearInvalid();
      var problem = validate();
      if (problem) { flagInvalid(problem); return; }
      if (!proofWorkerUrl && !workerUrl) { showMsg('Backend not configured. Cannot submit.', 'err'); return; }
      if (pendingUploads > 0) {
        submitWhenUploadsDone = true;
        submitBtn.disabled = true;
        submitBtn.textContent = 'Finishing your uploads…';
        showMsg('Hang tight, we\'ll send your brief as soon as your files finish uploading.', 'ok');
        return;
      }
      startSubmit();
    });

    function startSubmit() {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending…';
      submitMsg.hidden = true;

      if (proofWorkerUrl) {
        // Legacy Worker copy only when it's a different Worker (avoids double-posting the same brief)
        if (workerUrl && workerUrl.replace(/\/+$/, '') !== proofWorkerUrl) {
          fetch(workerUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(buildPayload()) }).catch(function () {});
        }
        submitToProof().then(function (result) {
          if (result.ok) {
            showMsg('Thanks, your brief is in. We\'ll be in touch shortly to confirm your quote.', 'ok');
            submitBtn.textContent = 'Sent ✓';
          } else {
            showMsg(failText(result.error), 'err');
            submitBtn.disabled = false;
            submitBtn.textContent = 'Send my brief';
          }
        });
        return;
      }

      fetch(workerUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(buildPayload()) })
        .then(function (res) { return res.json().then(function (b) { return { ok: res.ok, body: b, status: res.status }; }); })
        .then(function (r) {
          if (!r.ok || !r.body || !r.body.success) {
            var msg = (r.body && (r.body.error || r.body.message)) || ('HTTP ' + r.status);
            showMsg(failText(msg), 'err');
            submitBtn.disabled = false;
            submitBtn.textContent = 'Send my brief';
            return;
          }
          showMsg('Thanks, your brief is in. We\'ll be in touch shortly to confirm your quote.', 'ok');
          submitBtn.textContent = 'Sent ✓';
        })
        .catch(function (err) {
          showMsg(failText(err && err.message ? err.message : 'Network error'), 'err');
          submitBtn.disabled = false;
          submitBtn.textContent = 'Send my brief';
        });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  /* ── Utility cluster wiring ──────────────
     Lives here rather than in a section
     <script> so it survives cart.js AJAX
     re-renders.
  ─────────────────────────────────────────── */
  (function () {
    function bindSearch() {
      document.querySelectorAll('[data-li-open-search]').forEach(function (btn) {
        if (btn.dataset.liSearchBound === 'true') return;
        btn.dataset.liSearchBound = 'true';
        btn.addEventListener('click', function () {
          var trigger = document.querySelector('.header__icon--search summary')
            || document.querySelector('details-modal summary')
            || document.querySelector('.header__icon--search');
          if (trigger) trigger.click();
        });
      });
    }

    function syncCartCount() {
      var link = document.querySelector('.li-util__cart');
      if (!link) return;

      var source = document.querySelector('#cart-icon-bubble .cart-count-bubble');
      var count = '';
      if (source) {
        var match = source.textContent.replace(/\s+/g, ' ').match(/\d[\d,]*/);
        if (match) count = match[0];
      }

      var bubble = link.querySelector('.li-cart-bubble');
      if (count && count !== '0') {
        if (!bubble) {
          bubble = document.createElement('span');
          bubble.className = 'li-cart-bubble';
          bubble.setAttribute('aria-hidden', 'true');
          link.appendChild(bubble);
        }
        if (bubble.textContent !== count) bubble.textContent = count;
      } else if (bubble) {
        bubble.remove();
      }
    }

    /* Marks the Product Builder nav item as a
       launch point rather than a regular page:
       opens in a new tab and gets a small arrow
       icon appended to its label. Matched by href
       so it works no matter which snippet rendered
       the menu (dropdown vs. mega vs. drawer), and
       guarded so it never double-runs the item. */
    function markLaunchLinks() {
      var LAUNCH_PATH = '/pages/product-builder';
      document.querySelectorAll('.header__menu-item[href]').forEach(function (link) {
        if (link.dataset.liLaunchMarked === 'true') return;
        var url;
        try {
          url = new URL(link.getAttribute('href'), window.location.origin);
        } catch (e) {
          return;
        }
        if (url.pathname.indexOf(LAUNCH_PATH) === -1) return;

        link.dataset.liLaunchMarked = 'true';
        link.target = '_blank';
        link.rel = 'noopener';

        var icon = document.createElement('span');
        icon.className = 'li-launch-icon';
        icon.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M7 17 17 7"></path><path d="M9 7h8v8"></path></svg>';
        link.appendChild(icon);
      });
    }

    function init() {
      bindSearch();
      markLaunchLinks();
      var holder = document.getElementById('cart-icon-bubble');
      if (!holder) return;
      syncCartCount();
      new MutationObserver(syncCartCount).observe(holder, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.classList.contains('section-header')) init();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
